﻿export { LayerTree };
import { Circle as CircleStyle, Icon, Fill, Stroke, Style, Text, RegularShape } from 'ol/style.js';
import SldStyleParser from '../../../view-resources/Views/Map/geostyler-sld-parser/build/dist/SldStyleParser';
//import SldStyleParser2 from '../../geostyler-sld-parser/SldStyleParser';
import OlStyleParser from '../../../view-resources/Views/Map/geostyler-openlayers-parser/build/dist/OlStyleParser';
//import OlStyleParser2 from '../../geostyler-openlayers-parser/OlStyleParser';
//import OlLegend from '../../ol-ext/ol-ext';
import TileLayer from 'ol/layer/Tile.js';
import TileWMS from 'ol/source/TileWMS.js';
import TileGrid from 'ol/tilegrid/TileGrid.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import { bbox } from 'ol/loadingstrategy.js';
import truncate from '@turf/truncate';
import { Utility } from '../Utility.js';
import Point from 'ol/geom/Point.js';
import LineString from 'ol/geom/LineString.js';
import { Image as ImageLayer } from 'ol/layer.js';
import ImageWMS from 'ol/source/imageWMS.js';
import WMTSCapabilities from 'ol/format/WMTSCapabilities.js';
import WMTS, { optionsFromCapabilities } from 'ol/source/WMTS.js';
import { ImageArcGISRest, TileArcGISRest, OSM } from 'ol/source.js';
import EsriJSON from 'ol/format/EsriJSON.js';
import { createXYZ } from 'ol/tilegrid.js';
import { tile as tileStrategy } from 'ol/loadingstrategy.js';
import { defaults as defaultInteractions, Modify, Select, Snap } from 'ol/interaction.js';
import { createStyleFunction, createStyleFunctionFromUrl, createStyleFunctionFromUrlWithToken } from '../../ol-esri-style/index.js';
import HeatmapLayer from 'ol/layer/Heatmap.js';

/**
 * Class LayerTree
 * @param {object} settings, settings
 */
const LayerTree = function (settings) {

    //Define this
    var myLayerTree = this;

    // -- begin public variable -------------------------------------------------------------------

    // Layer tree object
    this.layerTreeObj = null;

    // Temporary Layer tree object
    this.tempLayerTreeObj = null;

    // Layer tree edit object
    this.layerTreeEditObj = null;

    // Layer tree edit object
    this.layerTreeSearchObj = null;

    // Layer tree location plant edit object
    this.layerTreeLocationPlantObj = null;

    // layerTree source
    this.layerInfo = null;

    // layerTree json
    this.layerTreeJson = null;

    // layerTreeEdit json
    this.layerTreeEditJson = null;

    // layerTreeSearch json
    this.layerTreeSearchJson = null;

    // layerTree location plant json
    this.layerTreeLocationPlantJson = null;

    // Selected layer for edition
    this.selectedLayer = null;

    // Selected layer for search
    this.selectedLayerSearch = null;

    // Geometry original before edit for undo
    this.featureSelectInfo = {
        geometry: null,
        id: null
    }

    // Mode Create
    this.modeCreateFeature = false;

    // Location plant layer id hash
    this.hashLocationPlantLayer = {};

    // Hash of layer name key to use information from layer info updated
    this.hashLayerNameKeyUpdatedLayerInfo = {};

    // Result WMST GetCapabilities
    //this._resultWmtsGetCapabilities = {};

    // Has form file for temporary layer import
    this._hashFormDataFileInfo = {};

    // Form data of layer file temporary
    this._formDataFileLayerTemporary = null;

    // Cache feature style
    this._cacheStyleFeature = {};

    // Cache style layer
    this._cacheStyleLayer = {};

    // Cache style layer
    this._cacheStyleLayerSign = {};

    this._cacheHidePrumoSigns = {};

    // Manager Traffic sign - Style prumo with alarm
    this._stylePrumoWithAlarm = [
        new Style({
            image: new CircleStyle({
                radius: 6,
                stroke: new Stroke({
                    color: '#232323',
                    width: 0.05
                }),
                fill: new Fill({
                    color: '#ff0000'
                })
            })
        }),
        new Style({
            image: new CircleStyle({
                radius: 4,
                stroke: new Stroke({
                    color: '#232323',
                    width: 0.05
                }),
                fill: new Fill({
                    color: '#ff0000'
                })
            })
        })
    ];

    // Manager Traffic sign - Style prumo without alarm
    this._stylePrumoWithoutAlarm = [
        new Style({
            image: new CircleStyle({
                radius: 5,
                stroke: new Stroke({
                    color: '#c43c39',
                    width: 1
                }),
                fill: new Fill({
                    color: '#ffffff'
                })
            })
        })//,
        //new Style({
        //    image: new CircleStyle({
        //        radius: 4,
        //        //stroke: new Stroke({
        //        //    color: '#000000',
        //        //    width: 0.05
        //        //}),
        //        fill: new Fill({
        //            color: '#ffffff'
        //        })
        //    })
        //})
    ];

    // Manager Traffic sign - Style support light sign
    this._styleSupportLightSign = [
        new Style({
            image: new CircleStyle({
                radius: 6,
                stroke: new Stroke({
                    color: '#00008B',
                    width: 2
                }),
                fill: new Fill({
                    color: '#ffffff'
                })
            })
        })
    ];

    // Key event addfeature on app.layerDraw*.getSource()
    this.keyLayerDrawAddFeatureEvent = null;

    // -- end public variable ---------------------------------------------------------------------

    // -- begin private variable ------------------------------------------------------------------

    // Settins for the Layer
    this._settings = settings;

    // Map for the Layer
    this._mapSgs;

    // Utility
    this._utility = new Utility();

    // Sdl parser
    this._sldStyleParser = new SldStyleParser();
    //this._sldStyleParser2 = new SldStyleParser2();
    this._olStyleParser = new OlStyleParser();
    //this._olStyleParser2 = new OlStyleParser2();

    // Legend
    //this._olLegend = new OlLegend();

    // Edit
    this._editLayerDataSource = {};
    this._onEdit = false;
    this._onCreate = false;

    // Search
    this._searchLayerDataSource = {};

    // Location plant
    this._locationPlantDataSource = {};

    // Hash label visible
    this._hashLabelVisible = {};

    // sub menu events
    this._eventSubmenuElement = {};

    // -- end private variable --------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Create layer tree (add layer)
     * @param {sgs.MapSgs} mapSgs, mapSgs
     * @param {object} treeMap, layertree
     */
    this.CreateLayerTree = function (mapSgs, treeMap) {
        // Set map
        myLayerTree._mapSgs = mapSgs;

        // Set feature style Cache
        myLayerTree._cacheStyleFeature = {}

        // Build layer tree json
        myLayerTree.layerTreeJson =
        {
            primaryKey: 'id',
            uiLibrary: 'materialdesign',
            //imageUrlField: 'data:image/png;base64,' || 'img', //'legendUrl',
            //imageHtml: '<img src="data:image/png;base64,"' + 
            dataSource: treeMap.list_layer_tree_info,
            checkboxes: true,
            checkedField: 'checked',
            cascadeCheck: true,
            nodeDataBound: function (e, node, id, record) {
                if (record.hasChildren === false) {
                    var idLayerNode = "id-layer-node-" + record.id;
                    var nodeWrapper = node.find('[data-role="wrapper"]');
                    var nodeImagen = node.find('[data-role="image"]');

                    nodeImagen.css('padding-left', '5px');
                    nodeImagen.css('padding-right', '5px');

                    node.attr("workspace", record.workspace);
                    node.attr("layer-name", record.layerName);
                    node.attr("layer-id", record.id);
                    node.attr("active-filter", "off");
                    node.attr("id", idLayerNode);
                    node.attr("is-leaf", record.children.length == 0);
                    node.css('word-break', 'break-all');
                    node.css('width', '330px'); // 275

                    var idLayerOperationZone = idLayerNode + '-operation-zone';

                    // Create layer filter active
                    nodeWrapper.append($('<span style="display: block;height: 5px;padding-top: 5px;color: red;display: table-cell;vertical-align: middle;text-align: right;"><i class="fa fa-filter layer-tree-filter-active" style="display:none;" title="filtro activo"></i></span>'));
                    // nodeWrapper.append($('<i class="fa fa-filter layer-tree-filter-active" style="display:none;" title="filtro activo"></i>'));
                    // Create layer geotemporal active
                    // nodeWrapper.append($('<i class="fa fa-clock-o layer-tree-geotemporal-active" style="display:none;" title="geotemporal activo"></i>'));

                    // Creating HTML element of Hide & Show subMenu Layer icon
                    var arrowButton = document.createElement('span');
                    arrowButton.classList.add('layer-options');
                    arrowButton.style.cursor = "pointer";
                    arrowButton.style.display = "table-cell";
                    arrowButton.style.verticalAlign = "middle";
                    arrowButton.style.position = "relative";
                    // arrowButton.style.cssFloat = "right";
                    arrowButton.style.textAlign = "right";
                    arrowButton.style.width = "30px";
                    arrowButton.innerHTML = '<i class="gj-icon chevron-down"></i>';
                    arrowButton.setAttribute("target-id", idLayerOperationZone);
                    nodeWrapper.append(arrowButton);

                    // Create layer operation zone
                    var layerOperationZone = document.createElement('div');
                    layerOperationZone.id = idLayerOperationZone;
                    layerOperationZone.style.paddingRight = '30px';
                    layerOperationZone.style.display = 'none';
                    node.append(layerOperationZone);

                    // Creating all button available operation zone
                    var idLayerOperationBtnZone = idLayerNode + "-operation-btn-zone";
                    var subMenuLayerElement = document.createElement('div');
                    subMenuLayerElement.id = idLayerOperationBtnZone;
                    subMenuLayerElement.classList.add('row');
                    subMenuLayerElement.style.gap = '8px';
                    subMenuLayerElement.style.justifyContent = 'center';
                    subMenuLayerElement.style.alignItems = 'center';
                    layerOperationZone.append(subMenuLayerElement);

                    // Create filter zone
                    var idLayerFilterZone = idLayerNode + "-layer-filter-zone";
                    var LayerFilterZoneElement = document.createElement('div');
                    LayerFilterZoneElement.id = idLayerFilterZone;
                    LayerFilterZoneElement.classList.add('operation-zone');
                    LayerFilterZoneElement.style.display = 'none';
                    layerOperationZone.append(LayerFilterZoneElement);
                    myLayerTree._BuildLayerOperationFilter(idLayerNode, idLayerFilterZone, record);

                    // Create opacity zone
                    var idLayerOpactityZone = idLayerNode + "-opactity-zone";
                    var LayerOpacityZoneElement = document.createElement('div');
                    LayerOpacityZoneElement.id = idLayerOpactityZone;
                    LayerOpacityZoneElement.classList.add('operation-zone');
                    LayerOpacityZoneElement.style.display = 'none';
                    layerOperationZone.append(LayerOpacityZoneElement);
                    myLayerTree._BuildLayerOperationOpacity(idLayerOpactityZone, record.id);

                    // Verify if legend is available for this layer
                    const legendAvailability = function (layerInfo) {
                        var result = true;
                        // Verify if layer as legend image for this layer
                        if (!(layerInfo.legend_img && layerInfo.legend_img.length > 0))
                            result = false;

                        return result;
                    };

                    // Verify if filter is available for this layer
                    const filterAvailability = function (layerInfo) {
                        var result = false;

                        if (layerInfo.layerOperation && layerInfo.kind != "WMS" && layerInfo.kind != "WMTS") {
                            result = JSON.parse(layerInfo.layerOperation).filter;
                        }
                        return result;
                    };

                    // Verify if opacity is available for this layer
                    const opacityAvailability = function (layerInfo) {
                        var result = false;
                        if (layerInfo.layerOperation) {
                            result = JSON.parse(layerInfo.layerOperation).opacity;
                        }

                        return result;
                    };

                    // Button options
                    var buttonOptions = [
                        { code: "filter", text: "Filtro alfanumérico", icon: "fa-filter", action: "openZone", event: 'click', params: { idNode: idLayerFilterZone }, verify: () => filterAvailability(record) },
                        { code: "opacity", text: "Opacidade", icon: "fa-sun-o", action: "openZone", event: 'click', params: { idNode: idLayerOpactityZone }, verify: () => opacityAvailability(record) },
                        { code: "legend", text: "Legenda", icon: "fa-image", action: "openPanel", event: 'click', params: { idLayer: record.id }, verify: () => legendAvailability(record) }
                    ];
                    buttonOptions.reverse();

                    // Creating a buttons for each button option
                    buttonOptions.forEach(function ({ code, text, icon, action, event, params, options, verify, execute }) {

                        if (!verify || (typeof verify == "function" && verify())) {
                            // Creating operation button
                            const idLayerOperationBtn = idLayerNode + '-' + code;
                            var buttonElement = document.createElement('button');
                            buttonElement.type = 'button';
                            buttonElement.classList.add('btn', 'btn-secondary', 'pull-right', 'layer-operation-btn');
                            buttonElement.style.padding = '5px';
                            buttonElement.style.minWidth = '30px';
                            buttonElement.style.marginRight = '5px';
                            buttonElement.style.backgroundColor = '#fff';
                            buttonElement.style.color = '#000';
                            buttonElement.title = text;
                            buttonElement.id = idLayerOperationBtn;

                            // Icon for the button
                            var iconElement = document.createElement('i');
                            iconElement.classList.add('fa', icon);
                            buttonElement.appendChild(iconElement);

                            // Adding the button to the container
                            subMenuLayerElement.appendChild(buttonElement);

                            // Add to event
                            if (!myLayerTree._eventSubmenuElement.hasOwnProperty(event)) {
                                myLayerTree._eventSubmenuElement[event] = {}
                            }

                            // create submenu for download
                            if (code == "download" && options && options.length > 0) {
                                // Generate download btn
                                options.map(option => {
                                    const idElementSubMenu = idLayerDownloadZone + '-' + option.code;

                                    // Add to event
                                    if (!myLayerTree._eventSubmenuElement.hasOwnProperty(option.event)) {
                                        myLayerTree._eventSubmenuElement[option.event] = {}
                                    }

                                    let elementSubMenu = null;
                                    switch (option.type) {
                                        case "toggle":
                                            const nameElement = idElementSubMenu + "-all-layer";
                                            elementSubMenu = document.createElement('label')
                                            elementSubMenu.id = idElementSubMenu + '-label';
                                            elementSubMenu.title = 'Exportar apenas área visível';
                                            elementSubMenu.htmlFor = idElementSubMenu;
                                            elementSubMenu.classList.add('label-switch', 'pull-right', 'layer-options-menu-switch');
                                            elementSubMenu.innerHTML = '<input type="checkbox" class="switch" name="' + nameElement + '" id="' + idElementSubMenu + '">' +
                                                '<span class="status"></span>';

                                            myLayerTree._eventSubmenuElement[option.event][idElementSubMenu] = option;
                                            break;
                                        case "button":
                                            elementSubMenu = document.createElement('button');
                                            elementSubMenu.classList.add('btn', 'btn-secondary', 'layer-operation-btn');
                                            elementSubMenu.style.padding = '5px';
                                            elementSubMenu.style.minWidth = '30px';
                                            elementSubMenu.style.marginRight = '5px';
                                            elementSubMenu.style.backgroundColor = '#fff';
                                            elementSubMenu.style.color = '#000';
                                            elementSubMenu.title = option.text;
                                            elementSubMenu.type = 'button';
                                            elementSubMenu.id = idElementSubMenu;

                                            var iconElement = document.createElement('i');
                                            iconElement.classList.add('fa', option.icon);

                                            elementSubMenu.appendChild(iconElement);

                                            myLayerTree._eventSubmenuElement[option.event][idElementSubMenu] = option;
                                            break;
                                        default:
                                            break;
                                    }

                                    if (elementSubMenu)
                                        LayerDownloadZoneElement.append(elementSubMenu);
                                });
                            }

                            // Action for every button
                            switch (action) {
                                case "openZone":
                                    myLayerTree._eventSubmenuElement[event][idLayerOperationBtn] = function () {
                                        // Close all other operation zone
                                        $('.operation-zone:not([id="' + params.idNode + '"])').hide();

                                        // Toggle operation zone
                                        $(`#${params.idNode}`).slideToggle();
                                    }
                                    break;
                                case "openPanel":
                                    // Add to event
                                    if (!myLayerTree._eventSubmenuElement.hasOwnProperty(event)) {
                                        myLayerTree._eventSubmenuElement[event] = {}
                                    }
                                    myLayerTree._eventSubmenuElement[event][idLayerOperationBtn] = function () {

                                        // Specific operation
                                        switch (code) {
                                            case "legend":
                                                myLayerTree._BuildlayerLegend(params);
                                                break;
                                            case "table":
                                                myLayerTree.ShowDataTableOfLayer(params);
                                                break;
                                            case "slider":
                                                myLayerTree._BuildLayerTimeLine(params)
                                            case "metadata":
                                                myLayerTree._ShowMetadata(params);
                                            default:
                                                // Toggle operation zone
                                                $(`#${params.idNode}`).slideToggle();
                                                break;
                                        }
                                    };
                                    break;
                                default:
                                    if (execute && typeof execute == 'function') {
                                        myLayerTree._eventSubmenuElement[event][idLayerOperationBtn] = arguments[0];
                                    }
                                    break;
                                // Do nothing
                            }
                        }

                        // If temporary layer execute data bound function to active all event for this node
                        if (record.isTemporaryLayer) {
                            myLayerTree._ExecuteLayerTreeDataBound(e);
                        }
                    })
                }
            },
            dataBound: function (e) {
                myLayerTree._ExecuteLayerTreeDataBound(e);
            },
            nodeDataBound_old: function (e, node, id, record) {
                if (record.hasChildren === false || record.children.length == 0) {
                    var idLayerInLayerTree = "id-layer-in-layer-tree-" + record.layerName + "-" + record.id;
                    var nodeDisplay = node.find('[data-role="display"]');
                    //nodeDisplay.addClass('go-to-location');
                    var layerName = record.workspace + ':' + record.layerName;
                    //nodeDisplay.attr('layer-name', layerName);
                    //nodeDisplay.attr('id_source', record.id_source);
                    node.attr("workspace", record.workspace);
                    node.attr("layer-name", record.layerName);
                    node.attr("layer-id", record.id);
                    node.attr("active-filter", "off");
                    node.attr("id", idLayerInLayerTree);

                    var idElementZoneOperation = 'id-layer-zone-operation-' + record.layerName + '-' + record.id;
                    var $openBtn = $('<i class="fa fa-chevron-down option-title-go-right-open layer-zone-operation" workspace="' + record.workspace + '" layer-name="' + record.layerName + '" layer-id="' + record.id + '"  target-id="' + idElementZoneOperation + '" style="font-size: 10px;top: 10px;display:none"></i>');
                    node.find("> div").append($openBtn);
                    node.find("> div").append($('<i class="fa fa-filter layer-tree-filter-active" style="display:none;" title="filto activo"></i>'));
                    node.append($('<div id="' + idElementZoneOperation + '" style="display:none;padding: 5px 10px 10px 24px;"></div>'));
                    $openBtn.show();

                    // Create Combo for choose column
                    var idElementZoneOperationSelectColumn = idElementZoneOperation + "-column-select";
                    var idElementZoneOperationSelectColumnZone = idElementZoneOperation + "-column-select-zone";
                    //var idElementZoneOperationAddFilterColumn = idElementZoneOperation + "-add-filter-column";
                    var idElementZoneOperationFilterZone = idElementZoneOperation + "-filter-zone";
                    var serviceType = record.kind;
                    if (record.codServerType == 'ARCGISSERVER') {
                        serviceType = record.codServiceType;
                    }
                    var $filter = (
                        '<div class="select-filter-zone">' +
                        '<div class=row style="height: 20px;">' +
                        '<label style="padding-left: 15px;font-size: 14px;font-weight: 100;position: relative; bottom: 1px;">Filtros</label>' +
                        '<a class="show-layer-filter-column" id-filter-column-select="' + idElementZoneOperationSelectColumn + '" style="padding-left: 10px;" title="Adicione um filtro"><i class="material-icons" style="font-size: 13px; font-weight: 100;">input</i></a>' +
                        '<a class="apply-layer-filter" id-filter-zone="' + idElementZoneOperationFilterZone + '" layer-in-tree-id="' + idLayerInLayerTree + '" style="padding-left: 10px;" title="Aplicar filtro a camada"><i class="material-icons" style="font-size: 13px; font-weight: 100;">refresh</i></a>' +
                        '<a class="remove-layer-filter" id-filter-zone="' + idElementZoneOperationFilterZone + '" layer-in-tree-id="' + idLayerInLayerTree + '" style="padding-left: 10px;" title="Remover filtro da camada"><i class="material-icons" style="font-size: 13px; font-weight: 100;">close</i></a>' +
                        '</div> ' +
                        '<div id="' + idElementZoneOperationSelectColumnZone + '" class="row" style="height: 4px;">' +
                        '<select id="' + idElementZoneOperationSelectColumn + '" id-layer="' + record.id + '" id-filter-zone="' + idElementZoneOperationFilterZone + '" class="form-control select-filter" title="Nenhuma coluna escolhida" data-container="body">' +
                        '</select>' +
                        '</div>' +
                        '</div>' +
                        '<div id="' + idElementZoneOperationFilterZone + '" class="filter-zone" style="padding-left:25px;" service-type="' + serviceType + '" id-layer="' + record.id + '"></div>');
                    //'<div class="col-md-1" style="padding: 0;position: relative;right: 24px;">' +
                    //'<button type="button" id="' + idElementZoneOperationAddFilterColumn + '" class="btn btn-primary" title="Adicionar campo" style="font-size: 8px;padding: 4px 8px;"><i class="fa fa-plus"></i></button>' +
                    //'</div>' +
                    //'</div>');
                    $('#' + idElementZoneOperation).append($filter);

                    var comboColumnLayer = [];
                    var listColumn = myLayerTree.layerInfo.dict_layer_info[record.id].list_column;
                    for (var i = 0; i < listColumn.length; i++) {
                        var searchable = listColumn[i].searchable;
                        // only if is searchable
                        if (searchable) {
                            comboColumnLayer.push(listColumn[i]);
                        }
                    }
                    //// Add sign type to prumo
                    //if (myLayerTree._mapSgs._settings._mapSettings.operation_visible.ManagerTrafficSignTool) {
                    //    if (myLayerTree._mapSgs._managerTrafficSignTool.prumoInfo.layerName == record.layerName) {
                    //        // Get sign type fom column sign
                    //        var layerInfoSign = Object.keys(myLayerTree._mapSgs._settings._mapSettings.tree_map.dict_layer_info).map(function (idLayer) { return myLayerTree._mapSgs._settings._mapSettings.tree_map.dict_layer_info[idLayer].layer_info }).find(c => c.layerName == myLayerTree._mapSgs._managerTrafficSignTool.signInfo.layerName);
                    //        var columnInfoSign = myLayerTree._mapSgs._settings._mapSettings.tree_map.dict_layer_info[layerInfoSign.id].list_column;
                    //        var columnTypeSinal = columnInfoSign.find(c => c.column_name == myLayerTree._mapSgs._managerTrafficSignTool.signInfo.signInfoConfig.column_name_type_sign);
                    //        comboColumnLayer.push(columnTypeSinal);
                    //    }
                    //}

                    // fill combo
                    myLayerTree._utility.FillSelectNormal(idElementZoneOperationSelectColumn, comboColumnLayer, 'pretty_name', 'column_name');
                }
            },
            dataBound_old: function (e) {

                // Go to layer
                //$('.go-to-location').on('click', function () {

                //    // fit to layer extent if user click on layer name on layertree
                //    let selLayer = parseInt(this.parentNode.parentNode.dataset.id);
                //    let selLayerText = app.sgs.Map.layerTree.layerInfo.dict_layer_info[selLayer].layer_info.text;
                //    let selLayerGeoServer = app.sgs.Map.layerTree.layerInfo.dict_layer_info[selLayer].layer_info.geoserver;
                //    let selLayerWorkspace = app.sgs.Map.layerTree.layerInfo.dict_layer_info[selLayer].layer_info.workspace;
                //    let selLayerLayerName = app.sgs.Map.layerTree.layerInfo.dict_layer_info[selLayer].layer_info.layerName;
                //    app.sgs.Map.getLayerBoundingBox(selLayerGeoServer, selLayerWorkspace, selLayerLayerName);

                //});

                // Open/close operation zone
                $('.layer-zone-operation').on('click', function () {
                    var idLayerOperation = $(this).attr("target-id");
                    $(this).toggleClass('fa-chevron-down fa-chevron-up');
                    if ($('#' + idLayerOperation).is(":visible"))
                        $('#' + idLayerOperation).hide();
                    else
                        $('#' + idLayerOperation).show();
                });

                // Refresh layer with filter type sign
                //$('.layer-zone-operation-type-sign-btn-refreh').on('click', function () {
                //    var idTypeSignSelect2 = $(this).attr("type-sign-selec2-id");
                //    var idLayerInTree = $(this).attr("layer-in-tree-id");
                //    var arrayTypeSignSelected = $('#' + idTypeSignSelect2).val();
                //    if (arrayTypeSignSelected.length == 0) {
                //        $('#' + idLayerInTree + ' .layer-tree-filter-active').hide();
                //        $('#' + idLayerInTree).attr("active-filter", "off");
                //    }
                //    else {
                //        $('#' + idLayerInTree + ' .layer-tree-filter-active').show();
                //        $('#' + idLayerInTree).attr("active-filter", "hide");
                //    }

                //    // Refresh layer
                //    var layerName = $('#' + idLayerInTree).attr("layer-name");
                //    var idLayer = $('#' + idLayerInTree).attr("layer-id");
                //    var layer = myLayerTree._mapSgs._utility.GetLayerById(myLayerTree._mapSgs.map, 'T' + idLayer);
                //    layer.getSource().clear();
                //});

                // Event view add filter
                $('.select-filter-zone .show-layer-filter-column').on('click', function (e) {
                    e.preventDefault();
                    var idElementZoneOperationSelectColumn = $(this).attr("id-filter-column-select");
                    $('#' + idElementZoneOperationSelectColumn).selectpicker('toggle');
                });

                // Event on select column for filter
                $('.select-filter-zone select.select-filter').on('change', function (e) {
                    e.preventDefault();
                    var idElementZoneOperationSelectColumn = this.id;
                    var idElementZoneOperationFilterZone = $(this).attr("id-filter-zone");
                    var columnName = $("#" + idElementZoneOperationSelectColumn).val();
                    var columnPrettyName = $('#' + idElementZoneOperationSelectColumn + ' option:selected').text();
                    var idLayer = $(this).attr("id-layer");
                    var layerInfo = myLayerTree._mapSgs._settings._mapSettings.tree_map.dict_layer_info[idLayer].layer_info;

                    myLayerTree._mapSgs.BuildLayerFilterFromLayerColumn(layerInfo, columnName, columnPrettyName, idElementZoneOperationFilterZone);
                });

                // Event apply filter
                $('.select-filter-zone .apply-layer-filter').on('click', function (e) {
                    e.preventDefault();
                    var idElementZoneOperationFilterZone = $(this).attr("id-filter-zone");
                    var idLayerInTree = $(this).attr("layer-in-tree-id");
                    var serviceType = $("#" + idElementZoneOperationFilterZone).attr("service-type");
                    var idLayer = $("#" + idElementZoneOperationFilterZone).attr("id-layer");
                    var layerName = myMapSgs._settings.treeMap.dict_layer_info[idLayer].layer_info.layerName;
                    var filter = myLayerTree._mapSgs.GenerateLayerFilter(idElementZoneOperationFilterZone, serviceType, layerName);
                    if (filter) {
                        myLayerTree._mapSgs._settings._mapSettings.tree_map.dict_layer_info[idLayer].layer_info["filterActive"] = filter;
                        myLayerTree._mapSgs._settings._mapSettings.tree_map.dict_layer_info[idLayer].layer_info["hasFilterActive"] = true;
                        $('#' + idLayerInTree + ' .layer-tree-filter-active').show();
                        $('#' + idLayerInTree).attr("active-filter", "hide");
                        var layer = myLayerTree._mapSgs._utility.GetLayerById(myLayerTree._mapSgs.map, 'T' + idLayer);
                        layer.getSource().clear();
                    }
                });

                // Event remove filter
                $('.select-filter-zone .remove-layer-filter').on('click', function (e) {
                    e.preventDefault();
                    var idElementZoneOperationFilterZone = $(this).attr("id-filter-zone");
                    var idLayerInTree = $(this).attr("layer-in-tree-id");
                    $("#" + idElementZoneOperationFilterZone).empty();
                    var idLayer = $("#" + idElementZoneOperationFilterZone).attr("id-layer");
                    myLayerTree._mapSgs._settings._mapSettings.tree_map.dict_layer_info[idLayer].layer_info["filterActive"] = "";
                    myLayerTree._mapSgs._settings._mapSettings.tree_map.dict_layer_info[idLayer].layer_info["hasFilterActive"] = false;
                    var layer = myLayerTree._mapSgs._utility.GetLayerById(myLayerTree._mapSgs.map, 'T' + idLayer);
                    layer.getSource().clear();
                    $('#' + idLayerInTree + ' .layer-tree-filter-active').hide();
                    $('#' + idLayerInTree).attr("active-filter", "off");
                });
            }
        };

        // -- Functionality for adding temporary layers --
        let canLoadTempGeom = myLayerTree._settings.getVisibleOperations().LoadGeom;
        if (canLoadTempGeom) {
            var myMapSgs = app.sgs.Map;
            var tempGeomArea = $('.temp-geom-area');

            // Build data source for layer tree
            myLayerTree._tempLayerDataSource = [{
                id: 1,
                idmap: 0,
                layerNameKey: "::1",
                pretty_name: "Camadas Temporárias",
                text: "Camadas Temporárias",
                minScale: 0,
                maxScale: 1000000,
                checked: false,
                tempChecked: false,
                checkedLocationPlant: false,
                hasChildren: true,
                children: [],
                layer_order: 1,
                editable: false,
                has_tooltip: true,
                has_statistic: true,
                is_pdm: false
            }];

            // Toggle temporary layers tree visibility
            myLayerTree.toggleTempGeomArea = function () {
                var curLayerCount = myMapSgs.layerTree.tempLayerTreeJson.dataSource[0].children.length;
                if (tempGeomArea.hasClass('hidden') && curLayerCount) {
                    tempGeomArea.removeClass('hidden');
                } else if (!tempGeomArea.hasClass('hidden') && !curLayerCount) {
                    tempGeomArea.addClass('hidden');
                }
            }

            // Build temporary layer tree json
            myLayerTree.tempLayerTreeJson =
            {
                primaryKey: 'id',
                uiLibrary: 'materialdesign',
                imageUrlField: 'legendUrl',
                dataSource: myLayerTree._tempLayerDataSource,
                checkboxes: true,
                checkedField: 'tempChecked',
                cascadeCheck: true,
                nodeDataBound: function (e, node, id, record) {
                    if (record.hasChildren === false) {
                        var nodeDisplay = node.find('[data-role="display"]');
                        nodeDisplay.addClass('go-to-location');
                        nodeDisplay.addClass('temp-layer-description');
                        nodeDisplay.attr('layer-name', record.layerName);

                    }
                },
                dataBound: function (e) {
                    // Go to layer
                    $('.go-to-location').on('click', function () {
                        // fit to layer extent if user click on layer name on layertree
                        var tempLayers = myMapSgs._layersTempGeom;
                        var layerToFetch = {};
                        var layerIndexToFetch = 0;
                        for (var i = 0; i < tempLayers.length; i++) {
                            if (tempLayers[i].values_.name == $(this).attr('layer-name')) {
                                layerToFetch = tempLayers[i];
                                layerIndexToFetch = i;
                            }
                        }
                        var newTempGeomExtent = layerToFetch.getSource().getExtent();
                        if (newTempGeomExtent[0] != 'Infinity')
                            app.sgs.Map.map.getView().fit(newTempGeomExtent, app.sgs.Map.map.getSize())
                    });
                }
            };

            // Initialize layer tree for temporary layer
            myLayerTree.tempLayerTreeObj = $('#temp-layer-tree').tree(myLayerTree.tempLayerTreeJson);

            /**
             * Create child temporary layer information
             * @param {string} layerId, layer id
             * @param {string} layerName, layer name
             * @param {string} layerNameTitle, layer title name
             * @param {string} layerPrettyName, layer pretty name
             * @param {string} workspace, layer workspace
             */
            myLayerTree.tempLayerTreeObj.getNewChild = function (layerId, layerName, layerNameTitle, layerPrettyName, workspace) {
                var externalGeoserverUrl = myLayerTree._mapSgs._utility.GetPropertyInfoInConfigArray(myLayerTree._mapSgs._settings.configurationInfo.propertyInfo, "LAYER_TEMPORARY", "LAYER_DEFINITION", "EXTERNAL_GEOSERVER_URL").value;
                var internalGeoserver = myLayerTree._mapSgs._utility.GetPropertyInfoInConfigArray(myLayerTree._mapSgs._settings.configurationInfo.propertyInfo, "LAYER_TEMPORARY", "LAYER_DEFINITION", "INTERNAL_GEOSERVER_URL").value;
                var legendStyleName = myLayerTree._mapSgs._utility.GetPropertyInfoInConfigArray(myLayerTree._mapSgs._settings.configurationInfo.propertyInfo, "LAYER_TEMPORARY", "LAYER_DEFINITION", "STYLE_NAME").value;
                var minScale = parseInt(myLayerTree._mapSgs._utility.GetPropertyInfoInConfigArray(myLayerTree._mapSgs._settings.configurationInfo.propertyInfo, "LAYER_TEMPORARY", "LAYER_DEFINITION", "MIN_SCALE").value);
                var maxScale = parseInt(myLayerTree._mapSgs._utility.GetPropertyInfoInConfigArray(myLayerTree._mapSgs._settings.configurationInfo.propertyInfo, "LAYER_TEMPORARY", "LAYER_DEFINITION", "MAX_SCALE").value);

                return {
                    id: layerId,
                    workspace: workspace,
                    layerName: layerName,
                    layerNameKey: workspace + ":" + layerName + ":" + layerId,
                    pretty_name: layerPrettyName,
                    text: "<span title='" + layerNameTitle + "'>" + layerPrettyName + '<i class="fa fa-times remove-icon" data-nodeid="' + layerId + '" data-geomname="' + layerName + '" ></i></span>',
                    kind: "WFS",
                    minScale: minScale,
                    maxScale: maxScale,
                    checked: false,
                    tempChecked: true,
                    checkedLocationPlant: false,
                    hasChildren: false,
                    children: [],
                    idparent: 1,
                    layer_order: layerId,
                    description: "",
                    editable: false,
                    has_tooltip: false,
                    has_statistic: false,
                    is_pdm: false,
                    internalGeoserver: internalGeoserver,
                    geoserver: externalGeoserverUrl,
                    sldName: legendStyleName,
                    sldNameLegend: legendStyleName,
                    legendUrl: externalGeoserverUrl + "/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=24&HEIGHT=24&LAYER=legend:legend_polygon&STYLE=" + workspace + ":Temp_Layer&legend_options=fontColor:0xffffff;fontSize:1&FORMAT=image/png&TRANSPARENT=TRUE"
                };
            }

            // Generate pretty name to add to layer tree
            myLayerTree.tempLayerTreeObj.generateFilePrettyName = function (file) {
                var tempLayers = myLayerTree.tempLayerTreeObj.getAll()[0].children;
                var duplicateNameCount = 0;
                for (var i = 0; i < tempLayers.length; i++) {
                    // If file with same name or same name and a counter with parenthesis added, mark as duplicate
                    if (tempLayers[i].pretty_name == file || tempLayers[i].pretty_name.substring(0, file.length - 1) == file + " (")
                        duplicateNameCount++;
                }

                // Add ellipsis to truncate long names
                if (file.length > 13) {
                    file = file.substring(0, 12) + "(...)";
                }

                return duplicateNameCount ? file + " (" + duplicateNameCount + ")" : file;
            }

            // Get index layer tree by id
            myLayerTree.tempLayerTreeObj.getJSONLayerIndexByLayerId = function (JSONLayers, id) {
                var layerTreeIndex = -1;
                for (var i = 0; i < JSONLayers.length; i++) {
                    if (JSONLayers[i].id == id) {
                        layerTreeIndex = i;
                    }
                }

                return layerTreeIndex;
            }

            // Visibility of the temporary layer
            myLayerTree.tempLayerTreeObj.tempCheckChange = function (e, $node, record, state) {
                var _idLayerTree = record.id;

                if (record.hasChildren === false) {
                    if (_idLayerTree) {
                        var tempLayers = myMapSgs._layersTempGeom;
                        var tempLayer = {};
                        for (var i = 0; i < tempLayers.length; i++) {
                            if (tempLayers[i].values_.name == record.layerName) {
                                tempLayer = tempLayers[i];
                            }
                        }

                        var tempTreeLayers = myMapSgs.layerTree.tempLayerTreeJson.dataSource[0].children;
                        var layerTreeIndexToUpdate = myLayerTree.tempLayerTreeObj.getJSONLayerIndexByLayerId(tempTreeLayers, tempLayer.values_.layerId);
                        if (state === 'unchecked') {
                            tempLayer.setVisible(false); // Toggle layer on map
                            tempTreeLayers[layerTreeIndexToUpdate].tempChecked = false; // Update temp layer checked status
                            myMapSgs._snappingTool.removeFeatures(tempLayer.getSource().getFeatures());
                        }
                        else {
                            tempLayer.setVisible(true); // Toggle layer on map
                            tempTreeLayers[layerTreeIndexToUpdate].tempChecked = true; // Update temp layer checked status
                            myMapSgs._snappingTool.addFeatures(tempLayer.getSource().getFeatures());
                        }
                    }
                }
            }

            // Remove temporary layer
            myLayerTree.tempLayerTreeObj.removeTempLayer = function () {
                // Prepare data for removal
                var myMapSgs = app.sgs.Map;
                var removeBtn = $(this);
                var idToRemove = removeBtn.data('nodeid');
                var layerNameToRemove = removeBtn.data('geomname');
                var nodeToRemove = myMapSgs.layerTree.tempLayerTreeObj.getNodeById(idToRemove);

                // Remove node from layer tree
                myMapSgs.layerTree.tempLayerTreeObj.removeNode(nodeToRemove);
                // Remove node from temporary layer data object
                var tempTreeLayers = myMapSgs.layerTree.tempLayerTreeJson.dataSource[0].children;
                var layerTreeIndexToRemove = myLayerTree.tempLayerTreeObj.getJSONLayerIndexByLayerId(tempTreeLayers, idToRemove);
                tempTreeLayers.splice(layerTreeIndexToRemove, 1);

                //remove from map
                var layerToRemove = myMapSgs._layersTempGeom
                var tempLayers = myMapSgs._layersTempGeom;
                var layerToRemove = {};
                var layerIndexToRemove = 0;
                for (var i = 0; i < tempLayers.length; i++) {
                    if (tempLayers[i].values_.name == layerNameToRemove) {
                        layerToRemove = tempLayers[i];
                        layerIndexToRemove = i;
                    }
                }
                // Remove layer features from snapping
                myMapSgs._snappingTool.removeFeatures(layerToRemove.getSource().getFeatures());
                //var layerFeatures = layerToRemove.getSource().getFeatures();
                //for (var i = 0; i < layerFeatures.length; i++)
                //    myMapSgs._snappingTool.snap.removeFeature(layerFeatures[i]);

                myMapSgs.map.removeLayer(layerToRemove); // Remove layer from ol map
                myMapSgs._layersTempGeom.splice(layerIndexToRemove, 1); // Remove layer from map layer list
                myLayerTree.toggleTempGeomArea();
            }

            // Get extent coordinate
            myLayerTree.extendCoords = function (extent1, extent2) {
                if (extent2[0] < extent1[0]) {
                    extent1[0] = extent2[0];
                }
                if (extent2[2] > extent1[2]) {
                    extent1[2] = extent2[2];
                }
                if (extent2[1] < extent1[1]) {
                    extent1[1] = extent2[1];
                }
                if (extent2[3] > extent1[3]) {
                    extent1[3] = extent2[3];
                }
                return extent1;
            }

            // Open file configuration
            myLayerTree.FileConfigurationToImport = function () {
                // Clean
                myLayerTree._hashFormDataFileInfo = {};
                $('#id-modal-temporary-layer-import-form').empty();

                var arraySrs = [
                    {
                        srs: myLayerTree._mapSgs._settings.projection.code_,
                        description: myLayerTree._mapSgs._settings._mapSettings.hash_proj4[myLayerTree._mapSgs._settings.projection.code_].name
                    },
                    {
                        srs: "EPSG:2190",
                        description: "Datum S. Braz-S. Miguel/UTM zona 26N"
                    }
                ];

                if (myLayerTree._mapSgs._settings.projection.code_ !== "EPSG:5015") {
                    arraySrs.push({
                        srs: "EPSG:5015",
                        description: "PTRA08 / UTM zone 26N"
                    });
                }

                var PathImport = "";

                $.ajax(
                    {
                        dataType: "json",
                        url: "/rest/app/Import/GetPathOgr",
                        async: false,
                        success: function (data) {
                            PathImport = data.result.value;
                        },
                        error: function (request, status, error) {
                            toastr["error"]("Erro no carregamento do caminho de carregamento");
                        }
                    });


                var countFile = myLayerTree._formDataFileLayerTemporary.getAll("files").length;
                for (var i = 0; i < countFile; i++) {
                    var fileObj = myLayerTree._formDataFileLayerTemporary.getAll("files")[0];
                    var cloneFileInfo = $('#id-modal-temporary-layer-import-zone-to-clone .file-info').clone(true);
                    var idClone = "id-modal-temporary-layer-import-file-info-" + i;
                    cloneFileInfo.attr("id", idClone);
                    $('#id-modal-temporary-layer-import-form').append(cloneFileInfo);
                    $('#' + idClone).find("span").each(function () {
                        this.setAttribute("name", this.getAttribute("name").replace('[0]', '[' + i + ']'));
                    });
                    // Fill length
                    $('#' + idClone + ' span.file-name')[0].innerHTML = fileObj.name;

                    $('#' + idClone + ' div.select-zone').append('<select id="id-modal-temporary-layer-import-file-info-srs-' + i + '" name="file_info[' + i + '][ssrs]" class="form-control one-way"></select>')
                    myLayerTree._utility.FillSelect('id-modal-temporary-layer-import-file-info-srs-' + i, arraySrs, 'description', 'srs');

                    myLayerTree._hashFormDataFileInfo[fileObj.name] = {
                        filePath: fileObj.name,
                        sSrs: arraySrs[0].srs,
                        tSrs: arraySrs[0].srs,
                        pos: i,
                        pathImport: PathImport
                    };
                }

                // Show modal
                $('#id-modal-temporary-layer-import').show();
            }

            // Import file
            $('#id-modal-temporary-layer-import-add').on('click', function () {
                myLayerTree.FileLayerToImport();
            });

            // Close modal
            $('#id-modal-temporary-layer-import-close').on('click', function () {
                $('#id-modal-temporary-layer-import').hide();
                $('#temp-upload-form input[name="files"]').val("");
            });

            // Open import layer file
            myLayerTree.FileLayerToImport = function () {
                myMapSgs._utility.ShowWait('offcanvas-map-spinner', true);

                // Close Modal
                $('#id-modal-temporary-layer-import').hide();

                // Get information
                for (var i = 0; i < Object.keys(myLayerTree._hashFormDataFileInfo).length; i++) {
                    var key = Object.keys(myLayerTree._hashFormDataFileInfo)[i];

                    myLayerTree._hashFormDataFileInfo[key].sSrs = $('#id-modal-temporary-layer-import-file-info-srs-' + myLayerTree._hashFormDataFileInfo[key].pos).val();
                }

                myLayerTree._formDataFileLayerTemporary.append("jsonSrsInfo", JSON.stringify(myLayerTree._hashFormDataFileInfo));

                $.ajax(
                    {
                        url: "/Maps/UploadTemp",
                        data: myLayerTree._formDataFileLayerTemporary,
                        processData: false,
                        contentType: false,
                        type: "POST",
                        success: function (data) {
                            if (data.error) {
                                toastr["error"]("Erro no carregamento da camada temporária");
                            }
                            else {
                                switch (data.result.status) {
                                    case 'SUCCESS':
                                        if (data.result.filePaths.length) {
                                            var uploadExtent = [];
                                            var fileExtentCount = data.result.filePaths.length;
                                            for (var i = 0; i < data.result.filePaths.length; i++) {
                                                var file = data.result.filePaths[i];
                                                $.ajax(
                                                    {
                                                        dataType: "json",
                                                        url: "/uploads/" + file + ".geojson",
                                                        success: function (data) {
                                                            var obj = { data: data, file: file };
                                                            myLayerTree.loadTempGeom(obj);
                                                        },
                                                        error: function (request, status, error) {
                                                            toastr["error"]("Erro no carregamento da camada temporária");
                                                            // Stop Spinner
                                                            myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                                                        }
                                                    });
                                            }
                                        }
                                        else {
                                            toastr["error"]("Erro no carregamento da camada temporária");
                                            // Stop Spinner
                                            myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                                        }

                                        $('#temp-upload-form input[name="files"]').val("");
                                        break;
                                    default:
                                        toastr["error"]("Erro no carregamento da camada temporária");
                                        // Stop Spinner
                                        myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                                }
                            }
                        },
                        error: function (request, status, error) {
                            toastr["error"]("Erro no carregamento da camada temporária");
                            // Stop Spinner
                            myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                        }
                    });
            }

            // Open temporary layer from file
            myLayerTree.handleAddGeom = function () {
                //var form = $('#temp-upload-form')[0];
                //var formDataFile = new FormData(form);
                //myLayerTree.FileConfigurationToImport(formDataFile);


                // Prepare handler for upload file change
                window['uploadTempFiles'] = function () {
                    var form = $('#temp-upload-form')[0];
                    myLayerTree._formDataFileLayerTemporary = new FormData(form);
                    myLayerTree.FileConfigurationToImport();
                }

                // Get file upload form and trigger click
                var tempUploadForm = $('#temp-upload-form');
                var tempUploadFile = tempUploadForm.find('input');
                tempUploadFile.off('change').on('change', function () { window['uploadTempFiles'](); });
                tempUploadFile.click();
            };

            // Enable upload button
            var btnTempUpload = '<button type="button" class="temp-upload-btn btn btn-primary btn-circle waves-effect waves-circle waves-float pull-left btn-layer-tree-footer-btn" title="Importar Camada temporária"><i class="material-icons">system_update_alt</i></button>';
            var tempGeomBtnArea = $('.temp-geom-btn-area');
            tempGeomBtnArea.append(btnTempUpload);
            var buttonAddGeom = $('.temp-geom-btn-area .temp-upload-btn');

            buttonAddGeom.on('click', myLayerTree.handleAddGeom);
            buttonAddGeom.on('touchstart', myLayerTree.handleAddGeom);
        }
        // -- End functionality for adding temporary layers --

        // -- Layer tree for edition --
        let canEditLayers = myLayerTree._settings.getVisibleOperations().EditLayers;
        if (canEditLayers) {
            // Get layer tree source
            myLayerTree._editLayerDataSource = treeMap.dict_layer_info;


            var DivAppend = '';

            $.each(myLayerTree._editLayerDataSource, function (index, value) {

                if (value.layer_info.editable) {

                    DivAppend += '<li class="style-edit-layer-element" data-id="' + value.layer_info.id + '" data-role="node">' + '<span data-role="image">' + value.layer_info.imageHtml + '</span>' + '<span data-role="display">' + value.layer_info.pretty_name + '</span>';

                    DivAppend += '</li>';

                    var a = index;

                }

            });

            $('#layer-tree-edit').append(DivAppend);

            //myLayerTree._editLayerDataSource = JSON.parse(JSON.stringify(treeMap.list_layer_tree_info));

            //for (let di = myLayerTree._editLayerDataSource.length - 1; di >= 0; di--) {
            //     if (myLayerTree._editLayerDataSource[di]["hasChildren"]) {
            //         for (let ci = myLayerTree._editLayerDataSource[di]["children"].length - 1; ci >= 0; ci--) {
            //             let ds = myLayerTree._editLayerDataSource[di]["children"][ci];
            //             if (ds["hasChildren"]) {
            //                 for (let c = ds["children"].length - 1; c >= 0; c--) {
            //                     if (ds["hasChildren"]) {
            //                         let cds = ds["children"][c];
            //                         for (let cc = cds["children"].length - 1; cc >= 0; cc--) {
            //                             let ccds = cds["children"][cc];
            //                             if (!ccds["editable"]) {
            //                                 cds["children"].splice(cc, 1);
            //                             }
            //                         }
            //                         if (!cds.hasChildren) {
            //                             if (!cds["editable"]) {
            //                                 ds["children"].splice(c, 1);
            //                             }
            //                         }
            //                     } else if (!ds["editable"]) {
            //                         myLayerTree._editLayerDataSource[di]["children"].splice(ci, 1);
            //                     }
            //                 }
            //             } else if (!ds["editable"]) {
            //                 myLayerTree._editLayerDataSource[di]["children"].splice(ci, 1);
            //             }
            //         }
            //     }
            // }

            // // Remove layer group with no layer for edition
            // for (let di = myLayerTree._editLayerDataSource.length - 1; di >= 0; di--) {
            //     if (myLayerTree._editLayerDataSource[di]["hasChildren"]) {
            //         if (!myLayerTree._editLayerDataSource[di]["children"] || myLayerTree._editLayerDataSource[di]["children"].length === 0)
            //             myLayerTree._editLayerDataSource.splice(di, 1);
            //         else {
            //             for (let ci = myLayerTree._editLayerDataSource[di]["children"].length - 1; ci >= 0; ci--) {
            //                 let ds = myLayerTree._editLayerDataSource[di]["children"][ci];
            //                 if (ds["hasChildren"]) {
            //                     if (!ds["children"] || ds["children"].length === 0)
            //                         myLayerTree._editLayerDataSource[di]["children"].splice(ci, 1);
            //                     else {
            //                         for (let c = ds["children"].length - 1; c >= 0; c--) {
            //                             if (ds["hasChildren"]) {
            //                                 if (!ds["children"] || ds["children"].length === 0)
            //                                     myLayerTree._editLayerDataSource[di]["children"].splice(ci, 1);
            //                             }
            //                         }
            //                     }
            //                 }
            //             }
            //         }
            //     }
            //}

            // // Layer tree definition
            // myLayerTree.layerTreeEditJson = {
            //     primaryKey: 'id',
            //     uiLibrary: 'materialdesign',
            //     //imageUrlField: 'img', //'legendUrl',
            //     dataSource: myLayerTree._editLayerDataSource                
            // };

            // Create html layer edit tree
            //myLayerTree.layerTreeEditObj = $('#layer-tree-edit').tree(myLayerTree.layerTreeEditJson);

            myLayerTree.layerTreeEditObj = $('#layer-tree-edit li');

            //// Event select layer for edition
            //myLayerTree.layerTreeEditObj.on('select', function (e, node, id) {
            //    if (node.children().length > 1)
            //        return false;
            //    myLayerTree.selectedLayer = node.data('id');
            //    myLayerTree.layerTreeObj.check(myLayerTree.layerTreeObj.getNodeById(myLayerTree.selectedLayer));
            //    $('#layer-edit-buttons').toggle('ol-hidden');
            //    mapSgs.handleEditButtonsVisibility(myLayerTree.layerInfo.dict_layer_info[myLayerTree.selectedLayer].layer_info.geomType);
            //});

            // Event select layer for edition
            myLayerTree.layerTreeEditObj.on('click', function (e, node, id) {
                myLayerTree.selectedLayer = this.dataset.id;
                myLayerTree.layerTreeObj.check(myLayerTree.layerTreeObj.getNodeById(myLayerTree.selectedLayer));

                if ($(this).hasClass('hold-background-style-edit-layer-element')) {
                    $(this).removeClass('hold-background-style-edit-layer-element');
                    $('#layer-edit-buttons').toggle('ol-hidden');
                } else {

                    $('#layer-tree-edit li').removeClass('hold-background-style-edit-layer-element');

                    $(this).addClass('hold-background-style-edit-layer-element');

                    if (!$('#layer-edit-buttons').is(':visible'))
                        $('#layer-edit-buttons').toggle('ol-hidden');

                }

                mapSgs.handleEditButtonsVisibility(myLayerTree.layerInfo.dict_layer_info[myLayerTree.selectedLayer].layer_info.geomType);
            });

            //// Event unselect layer for edition
            //myLayerTree.layerTreeEditObj.on('unselect', function (e, node, id) {
            //    myLayerTree.selectedLayer = null;
            //    $('#layer-edit-buttons').toggle('ol-hidden');
            //    mapSgs.handleEditButtonsVisibility();
            //    myLayerTree._InactivateInteractions();
            //});

            // Create layer function
            var createLayer = function () {
                //await myLayerTree._utility.Sleep(5000);

                if (mapSgs._utility.mobilecheck()) {
                    mapSgs._utility.ShowOpenCanvas3('offcanvas-theme-edit', false);
                }

                //await myLayerTree._utility.Sleep(5000);

                if (myLayerTree._onCreate) {
                    myLayerTree.CloseEdition(true);
                } else {
                    myLayerTree._InactivateInteractions();
                    myLayerTree._onCreate = true;
                    myLayerTree.modeCreateFeature = true;
                    myLayerTree._onEdit = false;
                    $('#layer-edit-create').addClass('selected');
                    $('#layer-edit-edit').removeClass('selected');
                    let layerToAdd = myLayerTree.layerInfo.dict_layer_info[myLayerTree.selectedLayer].layer_info;
                    let drawSource = undefined;
                    if (layerToAdd.geomType === 'polygon') {
                        app.Draw.setActive(true);
                        drawSource = app.layerDraw.getSource();
                    } else if (layerToAdd.geomType === 'line') {
                        app.DrawLine.setActive(true);
                        drawSource = app.layerDrawLine.getSource();
                    } else if (layerToAdd.geomType === 'point') {
                        app.DrawPoint.setActive(true);
                        //await myLayerTree._utility.Sleep(5000);
                        drawSource = app.layerDrawPoint.getSource();
                    }

                    if (drawSource)
                        myLayerTree.keyLayerDrawAddFeatureEvent = drawSource.on('addfeature', function () {
                            mapSgs.handleEditButtonsVisibility(layerToAdd.geomType, "create");
                        });
                }
            };

            // Edit layer function
            var editLayer = function () {
                if (myLayerTree._onEdit) {
                    myLayerTree.CloseEdition(true);
                } else {

                    // Remove event layer tooltips
                    mapSgs.map.un('singleclick', mapSgs.tooltips.BuildInfoTooltips);

                    if (mapSgs._utility.mobilecheck()) {
                        mapSgs._utility.ShowOpenCanvas3('offcanvas-theme-edit', false);
                    }

                    // Check if traffice tool is on clean info
                    if (myLayerTree._mapSgs._settings._mapSettings.operation_visible.TrafficSignTool) {
                        myLayerTree._mapSgs._trafficSignTool.Clean();
                    }

                    // Check if manager traffice tool is on clean info
                    if (myLayerTree._mapSgs._settings._mapSettings.operation_visible.ManagerTrafficSignTool) {
                        myLayerTree._mapSgs._managerTrafficSignTool.Clean();
                    }

                    myLayerTree._InactivateInteractions();
                    myLayerTree._onCreate = false;
                    myLayerTree._onEdit = true;
                    $('#layer-edit-create').removeClass('selected');
                    $('#layer-edit-edit').addClass('selected');
                    let layerToEdit = myLayerTree.layerInfo.dict_layer_info[myLayerTree.selectedLayer].layer_info;

                    app.CreateSelect([mapSgs._utility.GetLayerById(mapSgs.map, 'T' + layerToEdit.id)]);

                    app.Select.on('select', function (e) {
                        if (app.Select.getFeatures().getArray().length > 0) {
                            myLayerTree.featureSelectInfo.geometry = (app.Select.getFeatures().getArray()[0]).clone().getGeometry();
                            myLayerTree.featureSelectInfo.id = app.Select.getFeatures().getArray()[0].getId();
                        }
                        mapSgs.handleEditButtonsVisibility(layerToEdit.geomType, "edit");

                        var EditGeomLayers = myLayerTree._settings.getVisibleOperations().EditGeomLayers;

                        if (!EditGeomLayers) {

                            app.Modify.setActive(false);

                        }


                    });

                    // Remove event layer tooltips
                    mapSgs.map.un('singleclick', mapSgs.tooltips.BuildInfoTooltips);
                    // Change cursor
                    document.body.style.cursor = 'crosshair';
                }
            };

            // Event create layer
            $('#layer-edit-create').off('touchstart', createLayer).off('click', createLayer).on('click', createLayer).on('touchstart', createLayer);

            // Event edit layer
            $('#layer-edit-edit').on('click', editLayer).on('touchstart', editLayer);

        }
        // -- End layer tree for edition --

        // -- Layer tree for search --
        let canSearchLayers = myLayerTree._settings.getVisibleOperations().SearchLayers;
        if (canSearchLayers) {
            // Get layer tree source
            myLayerTree._searchLayerDataSource = JSON.parse(JSON.stringify(treeMap.list_layer_tree_info));

            // Layer tree definition
            myLayerTree.layerTreeSearchJson = {
                primaryKey: 'id',
                uiLibrary: 'materialdesign',
                //imageUrlField: 'img', //'legendUrl',
                dataSource: myLayerTree._searchLayerDataSource
            };

            // Create html layer edit tree
            myLayerTree.layerTreeSearchObj = $('#layer-search-layer-tree').tree(myLayerTree.layerTreeSearchJson);
            myLayerTree.layerTreeSearchObj.expandAll();

            // Event select layer for search
            myLayerTree.layerTreeSearchObj.on('select', function (e, node, id) {
                if (node.children().length > 1) {
                    $('#layer-search-active-tree label.layer-not-selected').show();
                    $('#layer-search-active-tree label.layer-selected').hide();
                    $('#layer-search-active-tree .layer-selected').remove();

                    return false;
                }

                $('#layer-search-filter-zone .form-group').remove();
                $('#layer-search-active-tree div.layer-selected').remove();

                myLayerTree.selectedLayerSearch = node.data('id');
                var cloneLayerSelected = $('#layer-search-layer-tree [data-id="' + myLayerTree.selectedLayerSearch + '"] div').clone();
                cloneLayerSelected.addClass("layer-selected");
                $('#layer-search-active-tree').append(cloneLayerSelected);
                $('#layer-search-active-tree label.layer-not-selected').hide();
                $('#layer-search-active-tree label.layer-selected').show();
                $('#layer-search-active-tree').trigger('click');

                // Fill column layer info
                var comboColumnLayer = [];

                for (var i = 0; i < myLayerTree.layerInfo.dict_layer_info[myLayerTree.selectedLayerSearch].list_column.length; i++) {
                    var searchable = myLayerTree.layerInfo.dict_layer_info[myLayerTree.selectedLayerSearch].list_column[i].searchable;
                    // only if is searchable
                    if (searchable) {
                        comboColumnLayer.push(myLayerTree.layerInfo.dict_layer_info[myLayerTree.selectedLayerSearch].list_column[i]);
                    }
                }
                // fill combo
                myLayerTree._utility.FillSelect('layer-search-select-column', comboColumnLayer, 'pretty_name', 'column_name');

                // Show form zone
                $('.layer-search-zone').removeClass('ol-hidden');
            });

            // Event unselect layer for search
            myLayerTree.layerTreeSearchObj.on('unselect', function (e, node, id) {
                $('#layer-search-active-tree label.layer-not-selected').show();
                $('#layer-search-active-tree label.layer-selected').hide();
                $('#layer-search-active-tree div.layer-selected').remove();

                // Clean combo
                myLayerTree._utility.FillSelect('layer-search-select-column', [], 'pretty_name', 'column_name');
            });
        }
        // -- End layer tree for search --

        // -- Layer tree for location plant --
        let canLocationPlantLayers = myLayerTree._settings.getVisibleOperations().LocationPlant;
        if (canLocationPlantLayers) {
            // Get layer tree source
            myLayerTree._locationPlantDataSource = JSON.parse(JSON.stringify(treeMap.list_layer_tree_info));

            // Get location plant configuration
            var settingLocationPlant = myLayerTree._settings.configurationInfo.locationPlantInfo;
            var locationPlantInfo = settingLocationPlant.definition.list_location_plant.find(c => c.location_plant_type = "PLANTA_LOCALIZACAO_DEFAULT");

            // Layer tree definition
            myLayerTree.layerTreeLocationPlantJson = {
                primaryKey: 'id',
                uiLibrary: 'materialdesign',
                //imageUrlField: 'img', //'legendUrl',
                dataSource: myLayerTree._locationPlantDataSource,
                checkboxes: true,
                checkedField: 'checkedLocationPlant',
                cascadeCheck: true,
                nodeDataBound: function (e, node, id, record) {
                    if (record.id_source !== null) {
                        if (record.checkedLocationPlant) {
                            // Get layer's parent name
                            var parentName = myLayerTree.getParentName(myLayerTree.layerTreeJson.dataSource, record.idparent);

                            myLayerTree.hashLocationPlantLayer[record.id + "." + parentName] = 1
                        }
                    }
                }
            };

            // Create html layer edit tree
            //if(_locationPlantLayerTreeVisible) {
            if (locationPlantInfo.has_layer_tree) {
                myLayerTree.layerTreeLocationPlantObj = $('#layer-location-plant-layer-tree').tree(myLayerTree.layerTreeLocationPlantJson);

                // Event on change checkbox
                myLayerTree.layerTreeLocationPlantObj.on('checkboxChange', function (e, $node, record, state) {
                    var _idLayerTree = record.id;

                    // var layerName = app.hashLayer[idLayerTree];
                    if (record.hasChildren === false) {
                        if (_idLayerTree) {

                            // Find layer parent's name
                            var parentName = myLayerTree.getParentName(myLayerTree.layerTreeJson.dataSource, record.idparent);
                            if (state === 'unchecked') {
                                delete myLayerTree.hashLocationPlantLayer[_idLayerTree];
                            }
                            else {
                                myLayerTree.hashLocationPlantLayer[_idLayerTree + "." + parentName] = 1;
                            }
                        }
                    }
                });
            }
        }
        // -- End Layer tree for location plant --

        // Layer info
        myLayerTree.layerInfo = treeMap;

        // Fill title layer tree
        var titleInfo = myLayerTree._utility.GetPropertyInfoInConfigArray(myLayerTree._mapSgs._settings.configurationInfo.propertyInfo, "MAP_COMPONENT", "LAYER_TREE", "TITLE");
        if (titleInfo !== undefined)
            $('#offcanvas-theme .title-layer-tree')[0].innerHTML = titleInfo.value;

        // Create html layer tree simplified
        if (myLayerTree._settings.getVisibleOperations().LayerTreeSimplified) {
            myLayerTree._BuildLayerTreeSimplified();
        }
        else {
            // Create html layer tree default
            myLayerTree.layerTreeObj = $('#layer-tree').tree(myLayerTree.layerTreeJson);

            // Event on change checkbox
            myLayerTree.layerTreeObj.on('checkboxChange', function (e, $node, record, state) {
                var _idLayerTree = record.id;

                //var layerName = app.hashLayer[idLayerTree];
                if (record.hasChildren === false) {
                    if (_idLayerTree) {
                        if (state === 'unchecked') {
                            myLayerTree._utility.GetLayerByName(mapSgs.map, record.layerNameKey).setVisible(false);
                        }
                        else {
                            myLayerTree._utility.GetLayerByName(mapSgs.map, record.layerNameKey).setVisible(true);
                        }
                    }
                }
            });
        }

        // Add layers to map
        myLayerTree._AddlayerMap(mapSgs.map, myLayerTree.layerTreeJson);
    };

    /**
     * Expand or collapse parent node
     * @param {any} treeObj
     * @param {any} ArraylayerInfo
     */
    this.ExpandOrCollapseNode = function (treeObj, ArraylayerInfo) {
        if (ArraylayerInfo.length > 0) {
            ArraylayerInfo.forEach(layerInfo => {
                if (layerInfo.children.length > 0) {
                    if (layerInfo.expand) {
                        var nodeToExpand = treeObj.getNodeById(layerInfo.id);
                        treeObj.expand(nodeToExpand);
                    }
                    else {
                        var nodeToCollapse = treeObj.getNodeById(layerInfo.id);
                        treeObj.collapse(nodeToCollapse);
                    }
                    myLayerTree.ExpandOrCollapseNode(treeObj, layerInfo.children);
                }
            });
        }
    }

    /**
     * Execute layer tree data bound event
     * @param {any} e, event
     */
    this._ExecuteLayerTreeDataBound = function (e) {
        // Go to layer
        $('.go-to-location').off('click').on('click', function () {

            // fit to layer extent if user click on layer name on layertree
            let selLayer = parseInt(this.parentNode.parentNode.dataset.id);
            let selLayerText = app.sgs.Map.layerTree.layerInfo.dict_layer_info[selLayer].layer_info.text;
            let selLayerGeoServer = app.sgs.Map.layerTree.layerInfo.dict_layer_info[selLayer].layer_info.geoserver;
            let selLayerWorkspace = app.sgs.Map.layerTree.layerInfo.dict_layer_info[selLayer].layer_info.workspace;
            let selLayerLayerName = app.sgs.Map.layerTree.layerInfo.dict_layer_info[selLayer].layer_info.layerName;
            app.sgs.Map.getLayerBoundingBox(selLayerGeoServer, selLayerWorkspace, selLayerLayerName);
        });

        // Hide/Show subMenu Layer
        $('.layer-options').off('click').on('click', function () {
            // Capturing the icon
            let icon = $(this).find('i');

            // Toggling the up and down arrow icon
            icon.toggleClass('chevron-down chevron-up');

            // Get zone operation id
            let idElementZoneOperation = $(this).attr("target-id");

            // Showing layer operation zone
            $("#" + idElementZoneOperation).slideToggle(400);
        });

        // Create event for all layer operation
        for (let typeEvent in myLayerTree._eventSubmenuElement) {
            for (let idElement in myLayerTree._eventSubmenuElement[typeEvent]) {
                if (myLayerTree._eventSubmenuElement[typeEvent].hasOwnProperty(idElement)) {
                    $("#" + idElement).off(typeEvent).on(typeEvent, function (element) {
                        const clickHandle = myLayerTree._eventSubmenuElement[typeEvent][element.currentTarget.id]

                        if (typeof clickHandle == 'function') {
                            clickHandle();
                        } else {
                            clickHandle.execute(clickHandle.params);
                        }
                    })
                }
            }
        }

        // -- begin event filter ----------------------------------------------------------

        // Event view add filter
        $('.select-filter-zone .show-layer-filter-column').off('click').on('click', function (e) {
            e.preventDefault();
            var idFilterSelectColumn = $(this).attr("id-filter-column-select");
            $('#' + idFilterSelectColumn).selectpicker('toggle');
        });

        // Event on select column for filter
        $('.select-filter-zone select.select-filter').off('change').on('change', function (e) {
            e.preventDefault();
            var idFilterSelectColumn = this.id;
            var idFilterZone = $(this).attr("id-filter-zone");
            var columnName = $("#" + idFilterSelectColumn).val();
            var columnPrettyName = $('#' + idFilterSelectColumn + ' option:selected').text();
            var idLayer = $(this).attr("id-layer");
            var layerInfo = myLayerTree._mapSgs._settings._mapSettings.tree_map.dict_layer_info[idLayer].layer_info;

            myLayerTree._mapSgs.BuildLayerFilterFromLayerColumn(layerInfo, columnName, columnPrettyName, idFilterZone);
        });

        // Event apply filter
        $('.select-filter-zone .apply-layer-filter').off('click').on('click', function (e) {
            e.preventDefault();
            var idFilterZone = $(this).attr("id-filter-zone");
            var idLayerNode = $(this).attr("layer-in-tree-id");
            var serviceType = $("#" + idFilterZone).attr("service-type");
            var idLayer = $("#" + idFilterZone).attr("id-layer");
            var filter = myLayerTree._mapSgs.GenerateLayerFilter(idFilterZone, serviceType);
            if (filter) {
                myLayerTree._mapSgs._settings._mapSettings.tree_map.dict_layer_info[idLayer].layer_info["filterActive"] = filter;
                myLayerTree._mapSgs._settings._mapSettings.tree_map.dict_layer_info[idLayer].layer_info["hasFilterActive"] = true;
                $('#' + idLayerNode + ' .layer-tree-filter-active').show();
                $('#' + idLayerNode).attr("active-filter", "hide");
                var layerInfo = myLayerTree._mapSgs._settings._mapSettings.tree_map.dict_layer_info[idLayer].layer_info;
                var layer = myLayerTree._mapSgs._utility.GetLayerById(myLayerTree._mapSgs.map, 'T' + idLayer);
                switch (serviceType) {
                    case "MapServer":
                        switch (layerInfo.kind) {
                            case "ImageEsri":
                                layer.getSource().refresh();
                                break;
                            case "TileEsri":
                                layer.getSource().refresh();
                                break;
                            case "VectorEsri":
                                layer.getSource().clear();
                                break;
                            default:
                            // do nothing
                        }
                        break;
                    case "FeatureServer":
                        switch (layerInfo.kind) {
                            case "VectorEsri":
                                layer.getSource().clear();
                                break;
                            default:
                            // do nothing
                        }
                        break;
                    case "WMS":
                        var source = layer.getSource();
                        var params = source.getParams();
                        params.cql_filter = filter;
                        params._random = Math.random();
                        source.updateParams(params);
                        source.setTileLoadFunction(tile => tile.setState(0));
                        layer.getSource().refresh();
                        layer.changed();
                        break;
                    case "WMS_ST":
                        var source = layer.getSource();
                        var params = source.getParams();
                        params.cql_filter = filter;
                        params._timestamp = new Date().getTime();
                        source.updateParams(params);
                        layer.getSource().refresh();
                        layer.changed();
                        break;
                    case "WMTS":
                        break;
                    case "WFS":
                        layer.getSource().clear();
                        break;
                    default:
                    // do nothing
                }
            }
        });

        // Event remove filter
        $('.select-filter-zone .remove-layer-filter').off('click').on('click', function (e) {
            e.preventDefault();
            var idFilterZone = $(this).attr("id-filter-zone");
            var idLayerNode = $(this).attr("layer-in-tree-id");
            var serviceType = $("#" + idFilterZone).attr("service-type");
            $("#" + idFilterZone).empty();
            var idLayer = $("#" + idFilterZone).attr("id-layer");
            myLayerTree._mapSgs._settings._mapSettings.tree_map.dict_layer_info[idLayer].layer_info["filterActive"] = "";
            myLayerTree._mapSgs._settings._mapSettings.tree_map.dict_layer_info[idLayer].layer_info["hasFilterActive"] = false;
            $('#' + idLayerNode + ' .layer-tree-filter-active').hide();
            $('#' + idLayerNode).attr("active-filter", "off");
            var layer = myLayerTree._mapSgs._utility.GetLayerById(myLayerTree._mapSgs.map, 'T' + idLayer);
            var layerInfo = myLayerTree._mapSgs._settings._mapSettings.tree_map.dict_layer_info[idLayer].layer_info;

            $('.select-filter-zone select.select-filter').find('option').prop('selected', false);

            switch (serviceType) {
                case "MapServer":
                    switch (layerInfo.kind) {
                        case "ImageEsri":
                            layer.getSource().refresh();
                            break;
                        case "TileEsri":
                            layer.getSource().refresh();
                            break;
                        case "VectorEsri":
                            layer.getSource().clear();
                            break;
                        default:
                        // do nothing
                    }
                    break;
                case "FeatureServer":
                    switch (layerInfo.kind) {
                        case "VectorEsri":
                            layer.getSource().clear();
                            break;
                        default:
                        // do nothing
                    }
                    break;
                case "WMS":
                    var source = layer.getSource();
                    var params = source.getParams();
                    if (layerInfo.cqlFilter)
                        params.cql_filter = layerInfo.cqlFilter;
                    else {
                        delete params.cql_filter;
                    }
                    params._random = Math.random();
                    source.updateParams(params);
                    source.setTileLoadFunction(tile => tile.setState(0));
                    layer.getSource().refresh();
                    layer.changed();
                    break;
                case "WMS_ST":
                    var source = layer.getSource();
                    var params = source.getParams();
                    if (layerInfo.cqlFilter)
                        params.cql_filter = layerInfo.cqlFilter;
                    else {
                        delete params.cql_filter;
                    }
                    params._timestamp = new Date().getTime();
                    source.updateParams(params);
                    layer.getSource().refresh();
                    layer.changed();
                    break;
                case "WMTS":
                    break;
                case "WFS":
                    layer.getSource().clear();
                    break;
                default:
                // do nothing
            }
        });

        // -- end event filter ------------------------------------------------------------

        // Expand or collapse parent node
        myLayerTree.ExpandOrCollapseNode($('#' + e.target.id).tree(), myLayerTree._mapSgs._settings._mapSettings.tree_map.list_layer_tree_info);
    }

    /**
     * Build legend layer
     * @param {any} params
     */
    this._BuildlayerLegend = function (params) {
        if ($('#id-layer-legend-img').is(":visible")) {
            // -- Close legend --

            // Close legend visibility
            $('#id-layer-legend-img').hide();

            // Reset view from layer external zone
            $('#id-layer-tree-external-zone').show();
            $('#id-offcanvas-theme-footer').show();
        }
        else {
            // -- Open legend --

            // Check legend active is from same layer
            var idLayerActive = $('#id-layer-legend-img').attr("id-layer");
            if (idLayerActive == params.idLayer) { // Only show the legend already loaded
                // Hide layer external zone
                $('#id-layer-tree-external-zone').hide();
                $('#id-offcanvas-theme-footer').hide();

                // Show legend
                $('#id-layer-legend-img').show();
            }
            else {
                // Set id layer
                $('#id-layer-legend-img').attr("id-layer", params.idLayer);

                // Get layer info
                var layerInfo = myLayerTree._mapSgs._settings._mapSettings.tree_map.dict_layer_info[params.idLayer].layer_info;

                // Clean legend zone
                $('#id-layer-legend-img-zone').empty();

                // Create legend
                var arrayLegend = eval(layerInfo.legend_img);
                var legendExists = false;
                if (arrayLegend) {
                    var pos = 0;
                    if (arrayLegend instanceof Array) {
                        arrayLegend.forEach(legendUrlInfo => {
                            if (legendUrlInfo.OnlineResource) {
                                var url = legendUrlInfo.OnlineResource.replace("[URL_FRONTEND]", window.location.origin);
                                var idImage = "id-layer-legend-img-to-zoom-" + pos++;
                                $('#id-layer-legend-img-zone').append('<img id="' + idImage + '" class="zoom layer-legend-img-to-zoom" src="' + url + '" data-magnify-src="' + url + '" />');
                                //$('#id-layer-legend-img-zone').append('<img id="' + idImage + '" class="zoom layer-legend-img-to-zoom" src="' + url + '"/>');
                                legendExists = true;
                            }
                        });
                    }
                    else {
                        var idImage = "id-layer-legend-img-to-zoom-" + pos;
                        var imageUrl = "/images/" + layerInfo.legend_img;
                        $('#id-layer-legend-img-zone').append('<img id="' + idImage + '" class="zoom layer-legend-img-to-zoom" src="' + imageUrl + '" data-magnify-src="' + imageUrl + '" />');
                        //$('#id-layer-legend-img-zone').append('<img id="' + idImage + '" class="zoom layer-legend-img-to-zoom" src="' + imageUrl + '" />');
                    }

                    // Create magnify glass
                    if (legendExists)
                        $('.layer-legend-img-to-zoom').magnify({
                            speed: 300,
                            magnifiedWidth: 300,
                            magnifiedHeight: 300
                        });
                }

                if (legendExists) {
                    // Hide layer external zone
                    $('#id-layer-tree-external-zone').hide();
                    $('#id-offcanvas-theme-footer').hide();

                    // Label
                    $("#id-layer-legend-img label").html("Legenda - " + layerInfo.pretty_name);

                    // Show legend
                    $('#id-layer-legend-img').show();
                }
                else {
                    // Set id layer a empty
                    $('#id-layer-legend-img').attr("id-layer", "");
                }
            }
        }
    }

    /**
    * Build html for layer filter operation
    * @param {string} idLayerNode, node identifier of the layer in layer tree
    * @param {string} idLayerFilterZone, node identifier of the filter zone of the layer
    * @param {object} layerInfo, layer information
    */
    this._BuildLayerOperationFilter = function (idLayerNode, idLayerFilterZone, layerInfo) {
        // Create Combo for choose column
        var idFilterSelectColumn = idLayerNode + "-column-select";
        var idFilterSelectColumnZone = idLayerNode + "-column-select-zone";
        var idFilterZone = idLayerNode + "-filter-zone";
        var serviceType = layerInfo.kind;
        if (layerInfo.codServerType == 'ARCGISSERVER') {
            serviceType = layerInfo.codServiceType;
        }
        var $filter = (
            '<div class="select-filter-zone">' +
            '<div class=row style="height: 20px;">' +
            '<label style="padding-left: 42px;font-size: 14px;font-weight: 100;position: relative; bottom: 1px;">Filtros</label>' +
            '<a class="show-layer-filter-column" id-filter-column-select="' + idFilterSelectColumn + '" style="padding-left: 10px;" title="Adicione um filtro"><i class="material-icons" style="font-size: 13px; font-weight: 100;">input</i></a>' +
            '<a class="apply-layer-filter" id-filter-zone="' + idFilterZone + '" layer-in-tree-id="' + idLayerNode + '" style="padding-left: 10px;" title="Aplicar filtro a camada"><i class="material-icons" style="font-size: 13px; font-weight: 100;">refresh</i></a>' +
            '<a class="remove-layer-filter" id-filter-zone="' + idFilterZone + '" layer-in-tree-id="' + idLayerNode + '" style="padding-left: 10px;" title="Remover filtro da camada"><i class="material-icons" style="font-size: 13px; font-weight: 100;">close</i></a>' +
            '</div> ' +
            '<div id="' + idFilterSelectColumnZone + '" class="row" style="height: 4px;">' +
            '<select id="' + idFilterSelectColumn + '" id-layer="' + layerInfo.id + '" id-filter-zone="' + idFilterZone + '" class="form-control select-filter" title="Nenhuma coluna escolhida" data-container="body">' +
            '</select>' +
            '</div>' +
            '</div>' +
            '<div id="' + idFilterZone + '" class="filter-zone" style="padding-left: 25px;" service-type="' + serviceType + '" id-layer="' + layerInfo.id + '"></div>');
        $('#' + idLayerFilterZone).append($filter);

        var comboColumnLayer = [];
        var layerInfoDict = myLayerTree.layerInfo.dict_layer_info[layerInfo.id];
        if (layerInfoDict) {
            var listColumn = JSON.parse(JSON.stringify(myLayerTree.layerInfo.dict_layer_info[layerInfo.id].list_column));
            listColumn.sort((a, b) => (a['column_pos'] > b['column_pos']) ? 1 : ((b['column_pos'] > a['column_pos']) ? -1 : 0));
            for (var i = 0; i < listColumn.length; i++) {
                // only if is visible
                if (listColumn[i].visible) {
                    comboColumnLayer.push(listColumn[i]);
                }
            }
        }

        // fill combo
        myLayerTree._utility.FillSelectNormal(idFilterSelectColumn, comboColumnLayer, 'pretty_name', 'column_name');
    }

    /*
     * Create panel to edit layer opacity
     * @param {any} idLayerOpactityZone
     * @param {any} idLayer
     */
    this._BuildLayerOperationOpacity = function (idLayerOpactityZone, idLayer) {

        const idRangeElement = idLayerOpactityZone + "-range"

        // create container display flex
        let divElement = document.createElement('div');
        divElement.style.display = "flex";
        divElement.style.padding = "5px 0px 5px 25px";

        // create input range
        let rangeElement = document.createElement('input');
        rangeElement.id = idRangeElement;
        rangeElement.classList.add('col-10');
        rangeElement.type = "range";
        rangeElement.min = 0;
        rangeElement.max = 1;
        rangeElement.step = 0.01;
        rangeElement.value = 1;
        rangeElement.style.height = "5px";
        rangeElement.style.borderRadius = "0px";
        rangeElement.style.border = "1px solid black";

        const idSpanElement = idLayerOpactityZone + "-span"

        // create span to show value
        let spanElement = document.createElement('span');
        spanElement.id = idSpanElement;
        spanElement.classList.add('col-2');
        spanElement.style.margin = "8px 0px 0px 4px";
        spanElement.style.fontSize = "11px";
        spanElement.style.fontWeight = "100";
        spanElement.style.width = "35px";
        spanElement.style.textAlign = "center";
        spanElement.innerText = "100%";

        // edit opacity layer
        const setOpacity = function (idLayer, opacity) {

            let layer = myLayerTree._mapSgs.map.getLayers().array_.find(layer => layer.values_.gpId == idLayer)

            if (layer) {
                layer.setOpacity(opacity);
                spanElement.innerText = `${(opacity * 100).toFixed(0)}%`;
            }
        }

        // register to range change value event from update opacity layer
        $(`#${idLayerOpactityZone}`).on('input', (e) => setOpacity(idLayer, parseFloat(e.target.value)));

        divElement.appendChild(rangeElement);
        divElement.appendChild(spanElement);

        $(`#${idLayerOpactityZone}`).append(divElement);
    }

    /**
     * Close edition layer
     * @param {bool} undoSelection, undo seleccion
     */
    this.CloseEdition = function (undoSelection) {
        if (myLayerTree._onCreate) {
            let layerToAdd = myLayerTree.layerInfo.dict_layer_info[myLayerTree.selectedLayer].layer_info;
            if (layerToAdd.geomType === 'polygon') {
                app.layerDraw.getSource().clear();
            } else if (layerToAdd.geomType === 'line') {
                app.layerDrawLine.getSource().clear();
            } else if (layerToAdd.geomType === 'point') {
                app.layerDrawPoint.getSource().clear();
            }
        }
        myLayerTree._onCreate = false;
        myLayerTree._onEdit = false;
        $('#layer-edit-create').removeClass('selected');
        $('#layer-edit-edit').removeClass('selected');
        myLayerTree._InactivateInteractions();
        // Reset event layer tooltips
        myLayerTree._mapSgs.map.on('singleclick', async (e) => { await myLayerTree._mapSgs.tooltips.BuildInfoTooltips(e); });
        // Reset cursor
        document.body.style.cursor = 'default';
        // Hide button
        $('#geometry-buttons-div').addClass('ol-hidden');
        $('#offcanvas-info').removeClass('expand');
        // Close info
        $('#offcanvas-info').removeClass('show');
        _controlOffCanvas.closeOffcanvasById('offcanvas-info');
        // Reset mode creation
        myLayerTree.modeCreateFeature = false;
        // Undo layer geometry
        if (undoSelection) {
            if (myLayerTree.featureSelectInfo.geometry) {
                var layerName = myLayerTree.layerInfo.dict_layer_info[myLayerTree.selectedLayer].layer_info.layerNameKey;
                var layer = myLayerTree._utility.GetLayerByName(myLayerTree._mapSgs.map, layerName);
                // Set feature
                layer.getSource().getFeatureById(myLayerTree.featureSelectInfo.id).setGeometry(myLayerTree.featureSelectInfo.geometry);
                layer.getSource().changed();
            }
        }
        // Close detail
        //$('#id-offcanvas-layer-detail').css({ 'transform': '' });
        //$('#id-offcanvas-layer-detail').removeClass('active');
        myLayerTree._utility.ShowOpenCanvas3('id-offcanvas-layer-detail', false);

        // Check if traffice tool is on clean info
        if (myLayerTree._mapSgs._settings._mapSettings.operation_visible.TrafficSignTool) {
            myLayerTree._mapSgs._trafficSignTool.Clean();
        }

        // Check if manager traffice tool is on clean info
        if (myLayerTree._mapSgs._settings._mapSettings.operation_visible.ManagerTrafficSignTool) {
            myLayerTree._mapSgs._managerTrafficSignTool.Clean();
        }
    };

    /**
     * Close edition layer
     * @param {bool} undoSelection, undo seleccion
     */
    this.CloseEdition2 = function (undoSelection, idLayer) {
        if (myLayerTree._onCreate) {
            let layerToAdd = myLayerTree.layerInfo.dict_layer_info[idLayer].layer_info;
            if (layerToAdd.geomType === 'polygon') {
                app.layerDraw.getSource().clear();
            } else if (layerToAdd.geomType === 'line') {
                app.layerDrawLine.getSource().clear();
            } else if (layerToAdd.geomType === 'point') {
                app.layerDrawPoint.getSource().clear();
            }
        }
        myLayerTree._onCreate = false;
        myLayerTree._onEdit = false;
        $('#layer-edit-create').removeClass('selected');
        $('#layer-edit-edit').removeClass('selected');
        myLayerTree._InactivateInteractions();
        // Reset event layer tooltips
        myLayerTree._mapSgs.map.on('singleclick', async (e) => { await myLayerTree._mapSgs.tooltips.BuildInfoTooltips(e); });
        // Reset cursor
        document.body.style.cursor = 'default';
        // Hide button
        $('#geometry-buttons-div').addClass('ol-hidden');
        $('#offcanvas-info').removeClass('expand');
        // Close info
        $('#offcanvas-info').removeClass('show');
        _controlOffCanvas.closeOffcanvasById('offcanvas-info');
        // Reset mode creation
        myLayerTree.modeCreateFeature = false;
        // Undo layer geometry
        if (undoSelection) {
            if (myLayerTree.featureSelectInfo.geometry) {
                var layerName = myLayerTree.layerInfo.dict_layer_info[idLayer].layer_info.layerNameKey;
                var layer = myLayerTree._utility.GetLayerByName(myLayerTree._mapSgs.map, layerName);
                // Set feature
                layer.getSource().getFeatureById(myLayerTree.featureSelectInfo.id).setGeometry(myLayerTree.featureSelectInfo.geometry);
                layer.getSource().changed();
            }
        }
        // Close detail
        $('#id-offcanvas-layer-detail').css({ 'transform': '' });
        $('#id-offcanvas-layer-detail').removeClass('active');

        // Check if traffice tool is on clean info
        if (myLayerTree._mapSgs._settings._mapSettings.operation_visible.TrafficSignTool) {
            myLayerTree._mapSgs._trafficSignTool.Clean();
        }

        // Check if manager traffice tool is on clean info
        if (myLayerTree._mapSgs._settings._mapSettings.operation_visible.ManagerTrafficSignTool) {
            myLayerTree._mapSgs._managerTrafficSignTool.Clean();
        }
    };

    this.CreateConsultaPublica = function () {

        if (myLayerTree._onCreate) {
            myLayerTree.CloseEdition(true);
        } else {
            myLayerTree._InactivateInteractions();
            myLayerTree._onCreate = true;
            myLayerTree.modeCreateFeature = true;
            myLayerTree._onEdit = false;
            $('#layer-edit-create').addClass('selected');
            $('#layer-edit-edit').removeClass('selected');
            let layerToAdd = myLayerTree.layerInfo.dict_layer_info[2828].layer_info;
            let drawSource = undefined;
            if (layerToAdd.geomType === 'polygon') {
                app.Draw.setActive(true);
                drawSource = app.layerDraw.getSource();
            } else if (layerToAdd.geomType === 'line') {
                app.DrawLine.setActive(true);
                drawSource = app.layerDrawLine.getSource();
            } else if (layerToAdd.geomType === 'point') {
                app.DrawPoint.setActive(true);
                //await myLayerTree._utility.Sleep(5000);
                drawSource = app.layerDrawPoint.getSource();
            }

            if (drawSource)
                drawSource.on('addfeature', function () {
                    myLayerTree._mapSgs.handleEditButtonsVisibility2(layerToAdd.geomType, "create");
                });
        }
    };

    /**
     * Close creation layer
     * @param {ol.layer} layerDraw, layer draw
     */
    this.CloseCreation = function (layerDraw) {
        myLayerTree._onCreate = false;
        myLayerTree._onEdit = false;
        $('#layer-edit-create').removeClass('selected');
        $('#layer-edit-edit').removeClass('selected');
        myLayerTree._InactivateInteractions();
        // Reset event layer tooltips
        myLayerTree._mapSgs.map.on('singleclick', async (e) => { await myLayerTree._mapSgs.tooltips.BuildInfoTooltips(e); });
        // Reset cursor
        document.body.style.cursor = 'default';
        // Hide button
        $('#geometry-buttons-div').addClass('ol-hidden');
        $('#offcanvas-info').removeClass('expand');
        // Close info
        $('#offcanvas-info').removeClass('show');
        _controlOffCanvas.closeOffcanvasById('offcanvas-info');
        // Remove layer geometry
        if (layerDraw) {
            layerDraw.getSource().clear();
        }
        // Close detail
        $('#id-offcanvas-layer-detail').css({ 'transform': '' });
        $('#id-offcanvas-layer-detail').removeClass('active');
    };

    /**
     * Find layer name key in layer struct
     * @param {string} layerName, layer name key to find
     */
    this.FindLayerNameKey = function (layerName) {
        for (let i = 0; i < Object.keys(myLayerTree.layerInfo.dict_layer_info).length; i++) {
            var key = Object.keys(myLayerTree.layerInfo.dict_layer_info)[i];
            var currentLayerName = myLayerTree.layerInfo.dict_layer_info[key].layer_info.layerName;
            if (currentLayerName === layerName) {
                return myLayerTree.layerInfo.dict_layer_info[key].layer_info.layerNameKey;
            }
        }

        return "";
    };

    /**
     * Find layer info in layer struct
     * @param {string} layerName, layer name key to find
     */
    this.FindLayerInfo = function (layerName) {
        for (let i = 0; i < Object.keys(myLayerTree.layerInfo.dict_layer_info).length; i++) {
            var key = Object.keys(myLayerTree.layerInfo.dict_layer_info)[i];
            var currentLayerName = myLayerTree.layerInfo.dict_layer_info[key].layer_info.layerName;
            if (currentLayerName === layerName) {
                return myLayerTree.layerInfo.dict_layer_info[key].layer_info;
            }
        }

        return null;
    };

    /**
     * Find layer info in layer struct by layer name key
     * @param {string} layerName, layer name key to find
     */
    this.FindLayerInfoByNameKey = function (layerNameKey) {
        for (let i = 0; i < Object.keys(myLayerTree.layerInfo.dict_layer_info).length; i++) {
            var key = Object.keys(myLayerTree.layerInfo.dict_layer_info)[i];
            if (myLayerTree.layerInfo.dict_layer_info[key].layer_info.layerNameKey === layerNameKey) {
                return myLayerTree.layerInfo.dict_layer_info[key].layer_info;
            }
        }

        return null;
    };

    this.loadTempGeom = function (data) {

        var uploadExtent = [];
        var fileExtentCount = 1;
        var myMapSgs = app.sgs.Map;
        var file = data.file;
        data = data.data;

        // Prepare new layer data
        var workspace = myLayerTree._mapSgs._utility.GetPropertyInfoInConfigArray(myLayerTree._mapSgs._settings.configurationInfo.propertyInfo, "LAYER_TEMPORARY", "LAYER_DEFINITION", "WORKSPACE").value;
        var newGeomId = 2; // Default first layer ID

        // If other layers presents, fetch next ID
        if (myMapSgs._layersTempGeom.length) {
            var lastGeomId = myMapSgs._layersTempGeom[myMapSgs._layersTempGeom.length - 1].values_.layerId;
            newGeomId = lastGeomId + 1;
        }
        var newGeomName = 'temp_geom_' + (newGeomId - 1); // Set new layer name
        var newGeomPrettyName = myLayerTree.tempLayerTreeObj.generateFilePrettyName(file);

        // Build new temporary Geom Layer
        var newLayer = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            style: myMapSgs._tempGeomStyles,
            name: newGeomName,
            layerId: newGeomId
        });
        var vectorSource = new VectorSource({
            features: (new GeoJSON()).readFeatures(data)
        });
        newLayer.setSource(vectorSource);
        myMapSgs._layersTempGeom.push(newLayer); // Add layer to map temp geom list
        myMapSgs.map.addLayer(newLayer); // Add layer to ol map

        // Add layer features to snapping tool
        myMapSgs._snappingTool.addFeatures(newLayer.getSource().getFeatures());
        //for (var i = 0; i < newLayer.getSource().getFeatures().length; i++)
        //   myMapSgs._snappingTool.snap.addFeature(newLayer.getSource().getFeatures()[i]);                                   

        // Update uploaded layers extent
        var newTempGeomExtent = newLayer.getSource().getExtent();
        if (newTempGeomExtent[0] != 'Infinity') {
            if (!uploadExtent.length) {
                uploadExtent = newTempGeomExtent;
            } else {
                uploadExtent = myLayerTree.extendCoords(uploadExtent, newTempGeomExtent);
            }
        }

        // Take Map to Uploaded Layers Extent when all layers loaded
        if (uploadExtent.length && --fileExtentCount == 0)
            myMapSgs.map.getView().fit(uploadExtent, myMapSgs.map.getSize());

        // Add layer to tree
        var newChild = myLayerTree.tempLayerTreeObj.getNewChild(newGeomId, newGeomName, file, newGeomPrettyName, workspace); // Generate new tree node to add
        myMapSgs.layerTree.tempLayerTreeJson.dataSource[0].children.push(newChild);

        // Rebuild tree with new data
        $('#temp-layer-tree').tree("destroy");
        var layerObj = $('#temp-layer-tree').tree(myMapSgs.layerTree.tempLayerTreeJson);

        // Expand temp geom tree
        myMapSgs.layerTree.tempLayerTreeObj.expand(app.sgs.Map.layerTree.tempLayerTreeObj.getNodeById(1)); // Expand parent node

        // Prepare checkbox click to toggle temp layers
        layerObj.on('checkboxChange', myLayerTree.tempLayerTreeObj.tempCheckChange);

        // Prepare layer removal
        $('.remove-icon').off('click').on('click', myLayerTree.tempLayerTreeObj.removeTempLayer);

        // Toggle temporary layers tree visibility
        myLayerTree.toggleTempGeomArea();

        // Finish loading
        myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);

        // Reset upload form
        var tempUploadForm = $('#temp-upload-form');
        tempUploadForm.find('input[type="file"]').remove();
        var newInput = '<input type="file" name="files" multiple />';
        tempUploadForm.append(newInput);

        // Show layer tree if not visible
        if (!$('#offcanvas-theme').hasClass('active')) {
            $('a[href="#offcanvas-theme"]').click();
        }
    }

    /**
     * Find all layer info in layer struct
     * @param {string} layerName, layer name key to find
     */
    this.FindAllLayerInfo = function (layerName) {
        var arrayLayerInfo = [];
        for (let i = 0; i < Object.keys(myLayerTree.layerInfo.dict_layer_info).length; i++) {
            var key = Object.keys(myLayerTree.layerInfo.dict_layer_info)[i];
            var currentLayerName = myLayerTree.layerInfo.dict_layer_info[key].layer_info.layerName;
            if (currentLayerName === layerName) {
                arrayLayerInfo.push(myLayerTree.layerInfo.dict_layer_info[key].layer_info);
            }
        }

        return arrayLayerInfo;
    };

    /**
     * Find layer info in layer struct by layer name
     * @param {string} layerName, layer name key to find
     */
    this.FindLayerInfoByLayerName = function (layerName) {
        for (let i = 0; i < Object.keys(myLayerTree.layerInfo.dict_layer_info).length; i++) {
            var key = Object.keys(myLayerTree.layerInfo.dict_layer_info)[i];
            var currentLayerName = myLayerTree.layerInfo.dict_layer_info[key].layer_info.layerName;
            if (currentLayerName === layerName) {
                return myLayerTree.layerInfo.dict_layer_info[key];
            }
        }

        return null;
    };

    /**
     * Find layer info in layer struct
     * @param {string} layerName, layer name key to find
     */
    this.FindLayerInfoOnListLayer = function (layerName) {
        for (let i = 0; i < Object.keys(myLayerTree._settings.treeMap.dict_layer_info).length; i++) {
            var key = Object.keys(myLayerTree._settings.treeMap.dict_layer_info)[i];
            var currentLayerName = myLayerTree._settings.treeMap.dict_layer_info[key].layer_info.layerName;
            if (currentLayerName === layerName) {
                return myLayerTree._settings.treeMap.dict_layer_info[key].layer_info;
            }
        }

        return null;
    };

    this.layerTreeVisible = function (map) {

        var layerInfoTmp = app.sgs.Map.layerTree.layerInfo;

        // get current zoom parameters
        let currentZoom = map.getView().getZoom();
        let currentScale = app.sgs.Map.layerTree._settings.scales[currentZoom];
        // console.log(currentScale);
        if (currentScale) {
            // go trough each layer, check if its max and min scales are whitin current scale
            for (let i = 0; i < Object.keys(layerInfoTmp.dict_layer_info).length; i++) {
                let lyrMaxScale = Object.values(layerInfoTmp.dict_layer_info)[i].layer_info.maxScale;
                let lyrMinScale = Object.values(layerInfoTmp.dict_layer_info)[i].layer_info.minScale;
                let lyrId = Object.values(layerInfoTmp.dict_layer_info)[i].layer_info.id;
                let isLyrInScaleRange = (currentScale >= lyrMinScale === currentScale < lyrMaxScale);

                for (let j = 0; j < $('#layer-tree li').length; j++) {

                    if ($('#layer-tree li')[j].outerHTML.startsWith('<li data-id="' + lyrId + '"')) {

                        if (!isLyrInScaleRange) {
                            $('#layer-tree li')[j].style.fontStyle = "italic";
                            $('#layer-tree li')[j].style.opacity = "0.7";

                        } else {
                            $('#layer-tree li')[j].style.fontStyle = "initial";
                            $('#layer-tree li')[j].style.opacity = "initial";
                        }
                    }
                }
            }
        }
    };

    /**
     * Get layer info in layer struct by layer source name
     * @param {string} layerName, layer source name key to find
     */
    this.GetLayerInfoArrayByLayerSourceName = function (layerName) {
        var layerInfoArray = [];
        for (let i = 0; i < Object.keys(myLayerTree.layerInfo.dict_layer_info).length; i++) {
            var key = Object.keys(myLayerTree.layerInfo.dict_layer_info)[i];
            var currentLayerName = myLayerTree.layerInfo.dict_layer_info[key].layer_info.layerName;
            if (currentLayerName === layerName) {
                layerInfoArray.push(myLayerTree.layerInfo.dict_layer_info[key].layer_info);
            }
        }

        return layerInfoArray;
    };

    /**
     * Get layer all info in layer struct by layer source name
     * @param {string} layerName, layer source name key to find
     */
    this.GetLayerAllInfoArrayByLayerSourceName = function (layerName) {
        var layerInfoArray = [];
        for (let i = 0; i < Object.keys(myLayerTree.layerInfo.dict_layer_info).length; i++) {
            var key = Object.keys(myLayerTree.layerInfo.dict_layer_info)[i];
            var currentLayerName = myLayerTree.layerInfo.dict_layer_info[key].layer_info.layerName;
            if (currentLayerName === layerName) {
                layerInfoArray.push(myLayerTree.layerInfo.dict_layer_info[key]);
            }
        }

        return layerInfoArray;
    };

    /**
     * Get layer info for selected layer
     */
    this.getVisibleLayers = function (scale) {

        var visibleNodeArray = myLayerTree.layerTreeObj.getCheckedNodes();
        var layerList = myLayerTree.layerInfo.dict_layer_info;
        var visibleLayerArray = [];
        var visibleLayerArrayInfo = [];

        for (var key in layerList) {

            if (visibleNodeArray.indexOf(parseInt(key)) != -1) {

                var layerInfo = layerList[key].layer_info;
                if (layerInfo.minScale <= scale && layerInfo.maxScale >= scale) {
                    visibleLayerArray.push(layerList[key]);
                    visibleLayerArrayInfo.push(layerInfo);
                }
            }
        }

        return {
            visibleLayerArray: visibleLayerArray,
            visibleLayerArrayInfo: visibleLayerArrayInfo
        }
    }

    /**
     * Get info for layer list
     * @param string host Host path for layer fetch
     * @param {array} arrayLayer array of layers
     */
    this.getVisibleLayerInfo = function (host, arrayLayer) {

        var layerInfo = [];
        for (var k = 0; k < arrayLayer.length; k++) {
            layerInfo.push({
                "name": arrayLayer[k].layer_info.text,
                "url": host + "/" + arrayLayer[k].layer_info.legendUrl,
                "geoserver": host + "/" + arrayLayer[k].layer_info.geoserver,
                "workspace": arrayLayer[k].layer_info.workspace,
                "layerNameKey": arrayLayer[k].layer_info.layerNameKey
            });
        }
        return layerInfo;
    }

    /**
    * Get Layer List
    * @param layerList Array with layer info
    */
    this.pushLayerInfo = function (layerInfoPoint, pointLayerList) {

        for (var i = 0; i < pointLayerList.length; i++) {

            if (typeof layerInfoPoint.find(l => l.name == pointLayerList[i].name) == "undefined") {
                layerInfoPoint.push(pointLayerList[i]);
            }
        }

        return layerInfoPoint;
    }

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    /**
     * Get Parent Name
     * Returns layer parent's name
     */
    this.getParentName = function (layerList, layerId) {
        var i, temp;
        for (i = 0; i < layerList.length; i++) {
            if (layerList[i].id == layerId) {
                return layerList[i].text;
            }
            if (layerList[i].children.length > 0) {
                temp = myLayerTree.getParentName(layerList[i].children, layerId);
                if (temp) {
                    if (typeof temp == "string")
                        return temp;
                    else
                        return temp.text;
                }
            }
        }
        return null;
    }

    /**
     * Inactive interaction
     */
    this._InactivateInteractions = function () {
        app.CreateSelect();
        app.Select.setActive(false);
        app.Draw.setActive(false);
        app.DrawLine.setActive(false);
        app.DrawPoint.setActive(false);
    };

    let zindex = 1;
    /**
     * Add all layer from layer tree to map. Recursive version
     */
    this._AddlayerMapRec = function (map, ChildrenArray) {

        for (var i = ChildrenArray["children"].length - 1; i >= 0; i--) {
            var Children = ChildrenArray["children"][i];

            if (Children["hasChildren"]) {

                myLayerTree._AddlayerMapRec(map, Children)

            }
            else {
                switch (Children["codServiceType"]) {
                    case "MapServer":
                    case "FeatureServer":
                        myLayerTree._AddEsriLayerToMap(map, Children, zindex++);
                        break;
                    default:
                        // Exclusive for traffic sign tool
                        if (myLayerTree._mapSgs._settings._mapSettings.operation_visible.ManagerTrafficSignTool) {
                            if (Children["layerName"] == myLayerTree._mapSgs._managerTrafficSignTool.roadInfo.layerNameView &&
                                myLayerTree._mapSgs._managerTrafficSignTool.roadInfo.layerNameView != myLayerTree._mapSgs._managerTrafficSignTool.roadInfo.layerNameProcess
                            ) {
                                myLayerTree._CreateInvisibleLayerWFS(
                                    map,
                                    (_geoserverAccess === "internal") ? Children["internalGeoserver"].slice(0, -1) : Children["geoserver"],
                                    Children["workspace"],
                                    myLayerTree._mapSgs._managerTrafficSignTool.roadInfo.layerNameProcess,
                                    Children["id"] + "_" + Children["id"],
                                    zindex++,
                                    Children["minScale"], Children["maxScale"]
                                );
                            }
                        }

                        // -- WMS --
                        if (Children["kind"] === 'WMS') {
                            if (Children["codServerType"] == "WMS_SERVICE") {
                                myLayerTree._AddWMSExternalLayerToMap(map, Children["id"], Children["internalGeoserver"], Children["layerName"], Children["checked"], zindex++, Children["minScale"], Children["maxScale"]);
                            }
                            else {
                                myLayerTree._AddWMSLayerToMap(
                                    map,
                                    Children["id"],
                                    (_geoserverAccess === "internal") ? Children["internalGeoserver"].slice(0, -1) : Children["geoserver"],
                                    Children["workspace"],
                                    Children["layerName"],
                                    Children["cqlFilter"],
                                    Children["sldName"],
                                    Children["checked"],
                                    zindex++,
                                    Children["minScale"],
                                    Children["maxScale"],
                                );
                            }
                        }
                        // -- WMS_ST --
                        else if (Children["kind"] === 'WMS_ST') {
                            if (Children["codServerType"] == "WMS_SERVICE") {
                                myLayerTree._AddWMSSTExternalLayerToMap(map, Children["id"], Children["internalGeoserver"], Children["layerName"], Children["checked"], zindex++, Children["minScale"], Children["maxScale"]);
                            }
                            else {
                                myLayerTree._AddWMSSTLayerToMap(
                                    map,
                                    Children["id"],
                                    (_geoserverAccess === "internal") ? Children["internalGeoserver"].slice(0, -1) : Children["geoserver"],
                                    Children["workspace"],
                                    Children["layerName"],
                                    Children["cqlFilter"],
                                    Children["sldName"],
                                    Children["checked"],
                                    zindex++,
                                    Children["minScale"],
                                    Children["maxScale"],
                                );
                            }
                        }
                        // -- WMTS --
                        else if (Children["kind"] === 'WMTS') {
                            if (Children["codServerType"] == "WMTS_SERVICE") {
                                myLayerTree._AddWMTSExternalLayerToMap(map, Children, zindex++)
                            }
                            else {
                                myLayerTree._AddWMTSLayerToMap(
                                    map,
                                    Children["id"],
                                    (_geoserverAccess === "internal") ? Children["internalGeoserver"].slice(0, -1) : Children["geoserver"],
                                    Children["workspace"],
                                    Children["layerName"],
                                    Children["cqlFilter"],
                                    Children["checked"],
                                    Children["minScale"],
                                    Children["maxScale"],
                                    Children["internalGeoserver"]
                                );
                            }
                        }
                        // -- WFS --
                        else if (Children["kind"] === 'WFS') {
                            if (Children["codServerType"] == "WFS_SERVICE") {
                                myLayerTree._AddWFSExternalLayerToMap(map, Children, zindex++);
                            }
                            else {
                                Children["geoserver"] = (_geoserverAccess === "internal") ? Children["internalGeoserver"].slice(0, -1) : Children["geoserver"];
                                myLayerTree._AddWFSLayertoMap(map, Children, zindex++);
                            }
                        }
                        break;
                }
            }
        }
    }

    /**
     * Add all layer from layer tree to map
     */
    this._AddlayerMap = function (map, lTreeJson) {
        for (var l = lTreeJson.dataSource.length - 1; l >= 0; l--) {
            if (lTreeJson.dataSource[l]["hasChildren"]) {
                myLayerTree._AddlayerMapRec(map, lTreeJson.dataSource[l])
            }
        }
    };

    /**
     * Add WFS Layer to Map
     * @param {ol.map} map, map
     * @param {string} id, id layer
     * @param {any} geoserver, geoserver
     * @param {any} workspace, workspace
     * @param {any} layerName, layer name
     * @param {string} legendUrl, image layer style
     * @param {any} cqlFilter, cql filter
     * @param {any} styleRule, style rule
     * @param {any} labelPropName, label property name
     * @param {any} sldName, sld name
     * @param {boolean} state, state visible
     * @param {int} index, index
     * @param {any} minScale, min scale
     * @param {any} maxScale, max scale
     * @param {bool} hasStyleJs, indicate to use style in js
     */
    //this._AddWFSLayertoMap = function (map, id, geoserver, workspace, layerName, legendUrl, cqlFilter, styleRule, labelPropName, sldName, state, index, minScale, maxScale, hasStyleJs) {
    this._AddWFSLayertoMap = function (map, layerInfo, index) {

        // Exclusive for traffic sign tool
        if (myLayerTree._mapSgs._settings._mapSettings.operation_visible.ManagerTrafficSignTool) {
            // Set sign or light sign layer
            //var layerNameSignObj = myLayerTree._mapSgs._utility.GetPropertyInfoInConfigArray(myLayerTree._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "SIGN_LAYER_NAME");
            if (layerInfo.layerName === myLayerTree._mapSgs._managerTrafficSignTool.signInfo.layerName ||
                layerInfo.layerName === myLayerTree._mapSgs._managerTrafficSignTool.lightSignInfo.layerName) {
                myLayerTree._CreateLayerWFSForSign(map, layerInfo, index);
                return;
            }
        }

        if (layerInfo.sldName && !layerInfo.hasStyleJs && !layerInfo.has_heatmap) {
            var sldNameWithExtension = layerInfo.sldName;
            if (sldNameWithExtension.substr(sldNameWithExtension.length - 4) !== '.sld')
                sldNameWithExtension += ".sld";
            var xhr = new XMLHttpRequest();
            xhr.open('GET', layerInfo.geoserver + '/rest/workspaces/' + layerInfo.workspace + '/styles/' + sldNameWithExtension, true);//, true, 'admin', 'geoserver');
            xhr.onload = function () {
                myLayerTree._sldStyleParser.readStyle(xhr.responseText).then(function (fromSLD) {
                    myLayerTree._olStyleParser.writeStyle(fromSLD).then(function (olStyle) {
                        var hasImage = false;
                        var style = olStyle[0];

                        // Verify if style is a image
                        for (var o in olStyle[0]) {
                            if (olStyle[0][o].image_) {
                                hasImage = true;
                                break;
                            }
                        }

                        // If is a image define style with this image
                        if (hasImage) {
                            style = myLayerTree._GetStyle(layerInfo.legendUrl);
                            hasImage = false;
                        }

                        // Layer whit specific style build in open layer
                        switch (layerInfo.layerName) {
                            case "Cemitérios":
                            case "Igrejas":
                            case "saude_hospital":
                            case "saude_unidade_saude":
                            case "saude_farmacia":
                            case "Culturais":
                            case "vw_administracao_servicos_bv":
                            case "vw_administracao_servicos_gnr":
                            case "vw_administracao_servicos_lit":
                            case "vw_administracao_servicos_iefp":
                            case "vw_administracao_servicos_tj":
                            case "vw_administracao_servicos_ctt":
                            case "vw_administracao_servicos_sf":
                            case "vw_administracao_servicos_irn":
                            case "vw_administracao_servicos_jf":
                            case "vw_administracao_servicos_cm":
                            case "vw_administracao_servicos_ss":
                            case "vw_ww_pipe_line_1":
                                hasImage = true;
                                break;
                            default:
                            // Do nothing
                        }

                        // For Manager traffic sign tool
                        //if (myLayerTree._mapSgs._settings._mapSettings.operation_visible.ManagerTrafficSignTool) {
                        //    // Get sign layer style
                        //    var layerNamePrumoObj = myLayerTree._mapSgs._utility.GetPropertyInfoInConfigArray(myLayerTree._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "PRUMO_LAYER_NAME");
                        //    if (layerNamePrumoObj && layerNamePrumoObj.value && layerInfo.layerName === layerNamePrumoObj.value) {
                        //        hasImage = true;
                        //    }
                        //}

                        // Create layer
                        //myLayerTree._CreateLayerWFS(map, id, geoserver, workspace, layerName, cqlFilter, labelPropName, style, !hasImage, state, index, minScale, maxScale);
                        myLayerTree._CreateLayerWFS(map, layerInfo, style, !hasImage, index);
                    });
                });
            };
            //xhr.withCredentials = true;
            xhr.send();
        }
        else {
            // Create layer
            if (layerInfo.has_heatmap) {
                myLayerTree._CreateLayerWFSHeatMap(map, layerInfo, index);
            }
            else {
                myLayerTree._CreateLayerWFS(map, layerInfo, myLayerTree._GetStyle(layerInfo.legendUrl), false, index);
            }
        }
    };

    /**
     * Create WFS heatmap layer
     * @param {any} map
     * @param {any} layerInfo
     * @param {any} index
     */
    this._CreateLayerWFSHeatMap = function (map, layerInfo, index) {

        // Vector Source
        var vectorSource = new VectorSource({
            visible: layerInfo.checked,
            format: new GeoJSON({ extractGeometryName: true }),
            url: function (extent) {
                // Clear layer label hash
                myLayerTree._hashLabelVisible = {};

                var layerInfoInUse = myLayerTree._mapSgs._settings._mapSettings.tree_map.dict_layer_info[layerInfo.id].layer_info;
                var cqlFilter = layerInfoInUse.cqlFilter;

                var proj = myLayerTree._settings.projection.getCode();
                var url = layerInfoInUse.geoserver + '/' + layerInfoInUse.workspace + '/ows?service=WFS&version=1.1.0&request=GetFeature'
                    + '&typename=' + layerInfoInUse.workspace + ':' + layerInfoInUse.layerName;

                // Add cql filter from layer tree filter
                if (layerInfoInUse["hasFilterActive"]) {
                    var cqlFilterToApply = layerInfoInUse["filterActive"];
                    if (cqlFilterToApply) {
                        if (cqlFilter != null && cqlFilter && cqlFilter != "") {
                            cqlFilter += " and ";
                        }
                        if (cqlFilter == null)
                            cqlFilter = cqlFilterToApply;
                        else
                            cqlFilter += cqlFilterToApply;
                    }
                }

                if (cqlFilter) {
                    url += '&cql_filter=' + encodeURI(cqlFilter) + " and BBOX(" + layerInfoInUse.geomColumnName + ", " + extent.join(',') + ")";
                    if (layerInfoInUse.layerName == 'vw_occurrence' && myLayerTree._settings._mapSettings.search_toponymy.workspaceSearchToponymy == 'GP_MEALHADA') {
                        var userDepartments = myLayerTree._settings.userInfo.list_department;
                        if (userDepartments) {
                            url += 'and%20(';
                            for (var i = 0; i < userDepartments.length; i++) {
                                if (i > 0) url += 'or%20';
                                url += 'departments%20LIKE%20%27%25' + userDepartments[i].cod_department + '%25%27%20';
                            }
                            url += ')';
                        }
                    }
                } else {
                    url += '&bbox=' + extent.join(',');
                }
                url += '&outputFormat=application/json'
                    + '&srsname=' + proj;

                return url;
            },
            strategy: bbox
        });

        // Layer
        const heatmapLayer = new HeatmapLayer({
            source: vectorSource,
            name: layerInfo.workspace + ":" + layerInfo.layerName + ":" + layerInfo.id,
            gpId: layerInfo.id,
            id: 'T' + layerInfo.id,
            zIndex: index,
            visible: layerInfo.checked,
            blur: 15,
            radius: 10,
            minResolution: layerInfo.minScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(layerInfo.minScale)] : myLayerTree._settings.resolutions[myLayerTree._settings.resolutions.length - 1],
            maxResolution: layerInfo.maxScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(layerInfo.maxScale)] + 0.1 : myLayerTree._settings.resolutions[0]
        });

        // Add layer to map
        map.addLayer(heatmapLayer);
    };

    /**
     * Create WFS layer
     * @param {ol.map} map, map
      * @param {string} id, id layer
     * @param {any} geoserver, geoserver
     * @param {any} workspace, workspace
     * @param {any} layerName, layer name
     * @param {any} cqlFilter, cql filter
     * @param {any} labelPropName, label property name
     * @param {ol.style} style, style
     * @param {boolean} isFromSLD, is style from sql
     * @param {boolean} state, state visible
     * @param {int} index, index
     * @param {any} minScale, min scale
     * @param {any} maxScale, max scale
     */
    this._CreateLayerWFS = function (map, layerInfo, style, isFromSLD, index) {
        // Set cql filter for vw_occurrence_event
        var cqlFilterResult = layerInfo.cqlFilter;
        switch (layerInfo.layerName) {
            case "vw_occurrence_event":
                if (myLayerTree._settings.getVisibleOperations().OccurrenceEvent)
                    cqlFilterResult += ' and id_user = ' + myLayerTree._settings.userInfo.userId;
                break;
            case "g_acessorios_cadastre":
            case "g_acessorios_transicao_cadastre":
            case "g_origens_cadastre":
            case "g_pontos_consumo_cadastre":
            case "g_prm_cadastre":
            case "g_purgas_cadastre":
            case "g_reservatorios_cadastre":
            case "g_valvulas_cadastre":
            case "g_proteccao_tubagem_cadastre":
            case "g_ramais_cadastre":
            case "g_tubagens_cadastre":
            case "g_telemetria_cadastre":
            case "g_unidades_filtragem_cadastre":
            case "g_respiros_cadastre":
            case "g_obra_cadastre":
                if (myLayerTree._settings.operationVisible.GoToCodObraCadastro && myLayerTree._settings.userInfo.Empreiteiro) {

                    if (cqlFilterResult) {
                        cqlFilterResult += " and cod_empreiteiro == '" + myLayerTree._settings.userInfo.Empreiteiro + "'";
                        layerInfo.cqlFilter += " and cod_empreiteiro == '" + myLayerTree._settings.userInfo.Empreiteiro + "'";
                    }
                    else {
                        cqlFilterResult = "cod_empreiteiro == '" + myLayerTree._settings.userInfo.Empreiteiro + "'";
                        layerInfo.cqlFilter = "cod_empreiteiro == '" + myLayerTree._settings.userInfo.Empreiteiro + "'";
                    }
                }
                break;
            default:
            // Do nothing
        }

        // Vector Source
        var vectorSource = new VectorSource({
            visible: layerInfo.checked,
            format: new GeoJSON({ extractGeometryName: true }),
            url: function (extent) {
                //var layerNameId = layerInfo.workspace + ":" + layerInfo.layerName + ":" + layerInfo.id;
                // Clear layer vector source to clean all feature layer in memory
                //myLayerTree._utility.GetLayerByName(myLayerTree._mapSgs.map, layerNameId).getSource().clear()

                // Clear layer label hash
                myLayerTree._hashLabelVisible = {};

                var layerInfoInUse = myLayerTree._mapSgs._settings._mapSettings.tree_map.dict_layer_info[layerInfo.id].layer_info;
                var cqlFilter = layerInfoInUse.cqlFilter;

                // Use layer info updated
                if (myLayerTree.hashLayerNameKeyUpdatedLayerInfo[layerInfo.layerNameKey] !== undefined) {
                    layerInfoInUse = myLayerTree.hashLayerNameKeyUpdatedLayerInfo[layerInfo.layerNameKey];
                    if (cqlFilter) {
                        // Set cql filter for vw_occurrence_event
                        switch (layerInfoInUse.layerName) {
                            case "vw_occurrence_event":
                                if (myLayerTree._settings.getVisibleOperations().OccurrenceEvent)
                                    cqlFilter += ' and id_user = ' + myLayerTree._settings.userInfo.userId;
                                break;
                            default:
                            // Do nothing
                        }
                    }
                }

                var proj = myLayerTree._settings.projection.getCode();
                var url = layerInfoInUse.geoserver + '/' + layerInfoInUse.workspace + '/ows?service=WFS&version=1.1.0&request=GetFeature'
                    + '&typename=' + layerInfoInUse.workspace + ':' + layerInfoInUse.layerName;

                // Add cql filter from layer tree filter
                if (layerInfoInUse["hasFilterActive"]) {
                    var cqlFilterToApply = layerInfoInUse["filterActive"];
                    if (cqlFilterToApply) {
                        if (cqlFilter != null && cqlFilter && cqlFilter != "") {
                            cqlFilter += " and ";
                        }
                        if (cqlFilter == null)
                            cqlFilter = cqlFilterToApply;
                        else
                            cqlFilter += cqlFilterToApply;
                    }
                }

                //if (mapSettings.operation_visible.ManagerTrafficSignTool) {

                //    // Prumo filter
                //    if (myLayerTree._mapSgs._managerTrafficSignTool.prumoInfo.layerName == layerInfoInUse.layerName) {
                //        var idFilterTypeSignSelect2 = "id-layer-zone-operation-" + layerInfoInUse.layerName + '-' + layerInfoInUse.id + "-type-sign-in-prumo-select2";
                //        var arrayTypeSignSelected = $('#' + idFilterTypeSignSelect2).val();
                //        if (arrayTypeSignSelected != undefined && arrayTypeSignSelected.length > 0) {
                //            var cqlFilterTypeSign = "";
                //            for (var i = 0; i < arrayTypeSignSelected.length; i++) {
                //                var idTypeSign = arrayTypeSignSelected[i];
                //                if (i != 0)
                //                    cqlFilterTypeSign += ' and ';
                //                cqlFilterTypeSign += myLayerTree._mapSgs._managerTrafficSignTool.prumoInfo.prumoInfoConfig.column_name_array_type_sign + " ilike '%[" + idTypeSign + "]%'";
                //            }
                //            if (cqlFilter != null && cqlFilter && cqlFilter != "") {
                //                cqlFilter += " and ";
                //            }
                //            if (cqlFilter == null)
                //                cqlFilter = cqlFilterTypeSign;
                //            else
                //                cqlFilter += cqlFilterTypeSign;
                //        }
                //    }
                //}

                if (cqlFilter) {
                    url += '&cql_filter=' + encodeURI(cqlFilter) + " and BBOX(" + layerInfoInUse.geomColumnName + ", " + extent.join(',') + ")";
                    if (layerInfoInUse.layerName == 'vw_occurrence' && myLayerTree._settings._mapSettings.search_toponymy.workspaceSearchToponymy == 'GP_MEALHADA') {
                        var userDepartments = myLayerTree._settings.userInfo.list_department;
                        if (userDepartments) {
                            url += 'and%20(';
                            for (var i = 0; i < userDepartments.length; i++) {
                                if (i > 0) url += 'or%20';
                                url += 'departments%20LIKE%20%27%25' + userDepartments[i].cod_department + '%25%27%20';
                            }
                            url += ')';
                        }
                    }
                } else {
                    url += '&bbox=' + extent.join(',');
                }
                url += '&outputFormat=application/json'
                    + '&srsname=' + proj;

                return url;
            },
            strategy: bbox
        });

        // Add label to stype if exists
        if (style && layerInfo.labelPropName) {
            var placement = 'point';
            switch (layerInfo.geomType) {
                case "line":
                    placement = 'line';
                    break;
                default:
                // do nothing
            };
            if (style && !(style instanceof Array)) {
                style = [style];
            }

            style.push(
                new Style({
                    text: new Text({
                        font: 'normal 11px Calibri', //"Verdana", "Open Sans", "Arial Unicode MS", "sans-serif"', //font: '12px Calibri,sans-serif',
                        placement: placement,
                        overflow: true,
                        fill: new Fill({
                            color: "rgba(255, 255, 255, 1)"
                        }),
                        stroke: new Stroke({
                            color: "rgba(0, 0, 0, 1)",
                            width: 3
                        }),
                        textBaseline: 'bottom',
                        offsetY: -2
                    })
                })
            );

            // Add style to feature function to rendering for every feature
            isFromSLD = false;

            // Cache layer style
            myLayerTree._cacheStyleLayer[layerInfo.layerNameKey] = style;
        }

        //var layerNamePrumo = "";
        //if (myLayerTree._mapSgs._settings._mapSettings.operation_visible.ManagerTrafficSignTool) {
        //    // Get sign layer style
        //    var layerNamePrumo = myLayerTree._mapSgs._utility.GetPropertyInfoInConfigArray(myLayerTree._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "PRUMO_LAYER_NAME").value;
        //}

        var vectorLayer = new VectorLayer({
            source: vectorSource,
            name: layerInfo.workspace + ":" + layerInfo.layerName + ":" + layerInfo.id,
            gpId: layerInfo.id,
            id: 'T' + layerInfo.id,
            zIndex: index,
            visible: layerInfo.checked,
            style: isFromSLD
                ? style
                : function (feature, resolution) {
                    var labelFreguesia = "";
                    var showLabel = true;
                    if (myLayerTree._cacheStyleLayer[layerInfo.layerNameKey] && style === undefined)
                        style = myLayerTree._cacheStyleLayer[layerInfo.layerNameKey];

                    //if (layerInfo.layerName == layerNamePrumo) {
                    //    var styleBuild = [
                    //        new Style({
                    //            image: new CircleStyle({
                    //                radius: 7,
                    //                stroke: new Stroke({
                    //                    color: '#232323',
                    //                    width: 0.1
                    //                }),
                    //                fill: new Fill({
                    //                    color: '#c43c39'
                    //                })
                    //            })
                    //        }),
                    //        new Style({
                    //            image: new CircleStyle({
                    //                radius: 4,
                    //                stroke: new Stroke({
                    //                    color: '#232323',
                    //                    width: 0.1
                    //                }),
                    //                fill: new Fill({
                    //                    color: '#ffffff'
                    //                })
                    //            })
                    //        }),
                    //    ];

                    //    return styleBuild;
                    //}

                    switch (layerInfo.layerName) {
                        case "PDL_JARDINS":
                            var styleBuild = [
                                new Style({
                                    stroke: new Stroke({
                                        color: 'rgba(0, 0, 0, 1)',
                                        opacity: 1,
                                        width: 1
                                    }),
                                    fill: new Fill({
                                        color: 'rgba(21, 204, 102, 1)'
                                    })
                                })
                            ];

                            return styleBuild;
                            break;
                        case "GEVESPACOVERDE":
                            var styleBuild = [
                                new Style({
                                    stroke: new Stroke({
                                        color: 'rgba(0, 0, 0, 1)',
                                        opacity: 1,
                                        width: 1
                                    }),
                                    fill: new Fill({
                                        color: 'rgba(0, 102, 51, 1)'
                                    })
                                })
                            ];

                            return styleBuild;
                            break;
                        case "Cemitérios":
                        case "Igrejas":
                        case "saude_hospital":
                        case "saude_unidade_saude":
                        case "saude_farmacia":
                        case "Culturais":
                        case "vw_administracao_servicos_bv":
                        case "vw_administracao_servicos_gnr":
                        case "vw_administracao_servicos_lit":
                        case "vw_administracao_servicos_iefp":
                        case "vw_administracao_servicos_tj":
                        case "vw_administracao_servicos_ctt":
                        case "vw_administracao_servicos_sf":
                        case "vw_administracao_servicos_irn":
                        case "vw_administracao_servicos_jf":
                        case "vw_administracao_servicos_cm":
                        case "vw_administracao_servicos_ss":
                            var style = myLayerTree._cacheStyleFeature[feature.getId()];
                            if (style)
                                return style;
                            else {
                                var styleBuild = null;
                                styleBuild = [
                                    //new Style({
                                    //    image: new RegularShape({
                                    //        fill: new Fill({ color: 'rgba(255, 255, 255, 1)' }),
                                    //        stroke: new Stroke({ color: 'rgba(35, 35, 35, 1)', width: 0.5 }),
                                    //        points: 4,
                                    //        radius: 20,
                                    //        angle: Math.PI / 4
                                    //    })
                                    //}),
                                    new Style({
                                        image: new Icon({
                                            src: location.origin + '/images/geoportal/lousada/' + layerInfo.layerName + '.png',
                                            //scale: 0.01,
                                            //width: 1,
                                            //height: 1
                                        })
                                    })
                                ];
                                myLayerTree._cacheStyleFeature[feature.getId()] = styleBuild;

                                return styleBuild;
                            }
                            break;
                        case "vw_sinalizacao_paragem_autocarro_geo":
                            var style = myLayerTree._cacheStyleFeature[feature.getId()];
                            if (style)
                                return style;
                            else {
                                var urlImage = feature.getProperties().file_img_name_sinal;
                                var styleBuild = null;
                                if (urlImage) {
                                    styleBuild = [new Style({
                                        image: new Icon({
                                            src: location.origin + urlImage,
                                            scale: feature.getProperties().scale_icon
                                        })
                                    })];
                                }
                                else {
                                    styleBuild = [new Style({
                                        image: new CircleStyle({
                                            radius: 5,
                                            stroke: new Stroke({
                                                color: '#000000',
                                                width: 3
                                            }),
                                            fill: new Fill({
                                                color: 'rgba(255, 255, 255, 0.8)'
                                            })
                                        })
                                    })];
                                };
                                myLayerTree._cacheStyleFeature[feature.getId()] = styleBuild;

                                return styleBuild;
                            }
                            break;
                        case "VW_RRVSINALIZACAO":
                            var style = myLayerTree._cacheStyleFeature[feature.getId()];
                            if (style)
                                return style;
                            else {
                                var imageName = feature.getProperties().T_SIIMAGEM;
                                var styleBuild = null;
                                if (imageName) {
                                    styleBuild = [new Style({
                                        image: new Icon({
                                            src: location.origin + '/images/traffic-signs2/' + imageName,
                                            scale: 0.1
                                        })
                                    })];
                                }
                                else {
                                    styleBuild = [new Style({
                                        image: new CircleStyle({
                                            radius: 5,
                                            stroke: new Stroke({
                                                color: '#000000',
                                                width: 3
                                            }),
                                            fill: new Fill({
                                                color: 'rgba(255, 255, 255, 0.8)'
                                            })
                                        })
                                    })];
                                };
                                myLayerTree._cacheStyleFeature[feature.getId()] = styleBuild;

                                return styleBuild;
                            }
                            break;
                        case "sinalizacao_vertical":
                            var style = myLayerTree._cacheStyleFeature[feature.getId()];
                            if (style)
                                return style;
                            else {
                                var imageName = feature.getProperties().cod_sinal;
                                var styleBuild = null;
                                if (imageName) {
                                    styleBuild = [new Style({
                                        image: new Icon({
                                            src: location.origin + '/images/traffic-signs2/' + imageName,
                                            scale: 0.1
                                        })
                                    })];
                                }
                                else {
                                    styleBuild = [new Style({
                                        image: new CircleStyle({
                                            radius: 5,
                                            stroke: new Stroke({
                                                color: '#000000',
                                                width: 3
                                            }),
                                            fill: new Fill({
                                                color: 'rgba(255, 255, 255, 0.8)'
                                            })
                                        })
                                    })];
                                };
                                myLayerTree._cacheStyleFeature[feature.getId()] = styleBuild;

                                return styleBuild;
                            }
                            break;
                        case "arborea_areas":
                            const dotPattern = myLayerTree._CreatePolygonDotPattern('green');
                            const stylePattern = new Style({
                                fill: new Fill({
                                    color: dotPattern, // Use the pattern here
                                }),
                                stroke: new Stroke({
                                    color: '#4daf4a',
                                    width: 1,
                                }),
                            });

                            return stylePattern;
                            break;
                        case "vw_freguesia_cont":
                            if (myLayerTree._mapSgs._settings.scales[myLayerTree._mapSgs._settings.resolutions.indexOf(resolution)] > 50000)
                                showLabel = false;
                        case "CAOPFreguesia2":
                        case "FREGUESIA":
                            if (showLabel)
                                labelFreguesia = feature.get(layerInfo.labelPropName);
                            var styleBuild = [
                                new Style({
                                    stroke: new Stroke({
                                        color: 'rgba(0, 0, 0, 1)',
                                        opacity: 1,
                                        width: 1
                                    }),
                                    fill: new Fill({
                                        color: 'rgba(0, 0, 0, 0.001)'
                                    })
                                }),
                                new Style({
                                    stroke: new Stroke({
                                        color: 'rgba(0, 0, 0, 1)',
                                        width: 2
                                    }),
                                }),
                                new Style({
                                    stroke: new Stroke({
                                        color: 'rgba(255, 255, 255, 1)',
                                        width: 1
                                    }),
                                }),
                                new Style({
                                    text: new Text({
                                        text: labelFreguesia,
                                        font: 'normal 11px Calibri', //"Verdana", "Open Sans", "Arial Unicode MS", "sans-serif"', //font: '12px Calibri,sans-serif',
                                        placement: placement,
                                        overflow: true,
                                        fill: new Fill({
                                            color: "rgba(255, 255, 255, 1)"
                                        }),
                                        stroke: new Stroke({
                                            color: "rgba(0, 0, 0, 1)",
                                            width: 3
                                        })
                                    })
                                })
                            ];

                            return styleBuild;
                            break;
                        case "vw_ww_pipe_line_1":
                            // Stroke style
                            var styleBuild = [
                                new Style({
                                    stroke: new Stroke({
                                        color: 'rgba(139, 139, 139, 1)',
                                        width: 3
                                    }),
                                }),
                                new Style({
                                    stroke: new Stroke({
                                        color: 'rgba(219, 182, 52, 1)',
                                        width: 1
                                    }),
                                })
                            ];

                            // Arrow style
                            var geometry = feature.getGeometry();
                            var arrayCoord = geometry.flatCoordinates;
                            var numberSegment = arrayCoord.length / 4;

                            var arrayPoint = [];
                            var dx = arrayCoord[2] - arrayCoord[0];
                            var dy = arrayCoord[3] - arrayCoord[1];
                            if (numberSegment == 1) {
                                arrayPoint = [arrayCoord[0] + dx / 2, arrayCoord[1] + dy / 2];
                            }
                            else {
                                arrayPoint = [arrayCoord[2], arrayCoord[3]];
                            }

                            var rotation = Math.atan2(dy, dx);
                            // arrows
                            styleBuild.push(new Style({
                                geometry: new Point(arrayPoint),
                                image: new Icon({
                                    src: '/images/arrow.png',
                                    anchor: [0.75, 0.5],
                                    rotateWithView: false,
                                    color: 'rgba(219, 182, 52, 1)',
                                    rotation: -rotation
                                })
                            }));

                            return styleBuild;
                            break;
                        case "vw_sinalizacao_suporte_sinal_luminoso_geo":
                            return myLayerTree._styleSupportLightSign;
                            break;
                        case "vw_sinalizacao_prumo_geo":
                            var hasAlarm = feature.getProperties().has_alarm_sign;
                            if (hasAlarm) {
                                return myLayerTree._stylePrumoWithAlarm;
                            }
                            return myLayerTree._stylePrumoWithoutAlarm;
                            break;
                        case "vw_occurrence":
                            // Type
                            var codType = feature.getProperties().cod_type;
                            var iconName = "";
                            switch (codType) {
                                case "EQUIPAMENTOS_MUNICIPAIS":
                                    iconName = "\uf1ad"; // "\uf3c5"; // TODO: Arrenjar simbolo
                                    break;
                                case "HIGIENE_URBANA":
                                    iconName = "\uf1fc";
                                    break;
                                case "ILUMINACAO_PUBLICA":
                                    iconName = "\uf0eb";
                                    break;
                                case "REDE_VIARIA":
                                    iconName = "\uf1b9";
                                    break;
                                case "AMBIENTE":
                                    iconName = "\uf1bb";
                                    break;
                                case "OUTROS":
                                    iconName = "\uf041";
                                    break;
                                case "EDUCACAO":
                                    iconName = "\uf19d"; // TODO: Arrenjar simbolo
                                    break;
                                case "BOMBEIROS":
                                    iconName = "\uf134"; // TODO: Arrenjar simbolo
                                    break;
                                case "FORCAS_SEGURANCA":
                                    iconName = "\uf183"; // TODO: Arrenjar simbolo 
                                    break;
                                case "AGUA_SANEAMENTO":
                                    iconName = "\uf043";
                                    break;
                                case "INCIDENTE":
                                    iconName = "\uf071";
                                    break;
                                case "INTERVENCOES_PLANEADAS":
                                    iconName = "\uf0ad";
                                    break;
                                case "ANOMALIA":
                                    iconName = "\uf127";
                                    break;
                                default:
                                // do nothing
                            };

                            // Color state
                            var codState = feature.getProperties().cod_state;
                            var fillColor = "";
                            var strokeColor = "";
                            switch (codState) {
                                case "ABERTA":
                                    fillColor = '#fbb200'; // '#FFFF00';
                                    strokeColor = '#FF0000';
                                    break;
                                case "ATRIBUIDA":
                                    fillColor = '#cccc00'; // '#1ad3ee';
                                    strokeColor = '#00000';
                                    break;
                                case "EM_RESOLUCAO":
                                    fillColor = '#073A42'; // '#1ad3ee';
                                    strokeColor = '#00000';
                                    break;
                                case "CONCLUIDA":
                                    fillColor = '#46782D'; // '#8df05b';
                                    strokeColor = '#469220';
                                    break;
                                case "FECHADA":
                                    fillColor = '#46782D'; // '#8df05b';
                                    strokeColor = '#FF0000';
                                    break;
                                default:
                                // do nothing
                            }

                            if (iconName) {
                                styleBuild = new Style({
                                    image: new CircleStyle({
                                        radius: 20,
                                        stroke: new Stroke({
                                            color: '#000000',
                                            width: 3
                                        }),
                                        fill: new Fill({
                                            color: 'rgba(255, 255, 255, 0.8)'
                                        })
                                    }),
                                    text: new Text({
                                        text: iconName,
                                        font: 'normal 22px FontAwesome',
                                        textBaseline: 'middle',
                                        //
                                        fill: new Fill({
                                            color: fillColor,
                                            strokeColor: strokeColor
                                        })
                                    })
                                });

                                return styleBuild;
                            }
                            else
                                return style;
                            break;
                        case "V_ESTRADAS":
                            if (layerInfo.labelPropName) {
                                if (style instanceof Array) {
                                    if (myLayerTree._mapSgs._settings.scales[myLayerTree._mapSgs._settings.resolutions.indexOf(resolution)] < 10000) {
                                        var label = feature.get(layerInfo.labelPropName);
                                        if (!myLayerTree._hashLabelVisible[label]) {
                                            style[style.length - 1].getText().setText(label);
                                            myLayerTree._hashLabelVisible[label] = 1;
                                        }
                                        else
                                            style[style.length - 1].getText().setText("");
                                    }
                                    else {
                                        style[style.length - 1].getText().setText("");
                                    }
                                }
                            }
                            return style;
                            break;
                        case "VW_NPOLICIA_III":
                        case "NPOLICIA":
                            if (layerInfo.labelPropName) {
                                if (style instanceof Array) {
                                    if (myLayerTree._mapSgs._settings.scales[myLayerTree._mapSgs._settings.resolutions.indexOf(resolution)] <= 5000) {
                                        var label = feature.get(layerInfo.labelPropName);
                                        style[style.length - 1].getText().setText(label);
                                    }
                                    else {
                                        style[style.length - 1].getText().setText("");
                                    }
                                    // If police not associate with subroad
                                    if (
                                        feature.getProperties().IDFREGUESIATROCO === null ||
                                        feature.getProperties().IDFREGUESIATROCO === "" ||
                                        feature.getProperties().IDFREGUESIATROCO === 0
                                    ) {
                                        if (style.length === 2) {
                                            style.unshift(new Style({
                                                image: new CircleStyle({
                                                    radius: 5,
                                                    stroke: new Stroke({
                                                        color: '#ff3d00',
                                                        width: 1
                                                    }),
                                                    fill: new Fill({
                                                        color: 'rgba(255, 0, 0, 1)'
                                                    })
                                                })
                                            }));
                                        }
                                    }
                                    else {
                                        if (style.length === 3) {
                                            style.shift();
                                        }
                                    }
                                }
                            }
                            return style;
                            break;
                        default:
                            if (layerInfo.labelPropName) {
                                if (style instanceof Array) {
                                    if (myLayerTree._mapSgs._settings.scales[myLayerTree._mapSgs._settings.resolutions.indexOf(resolution)] <= 10000) {
                                        var label = feature.get(layerInfo.labelPropName);
                                        if (!myLayerTree._hashLabelVisible[label]) {
                                            style[style.length - 1].getText().setText(label);
                                            myLayerTree._hashLabelVisible[label] = 1;
                                        }
                                        else
                                            style[style.length - 1].getText().setText("");
                                    }
                                    else {
                                        style[style.length - 1].getText().setText("");
                                    }
                                }
                            }
                            return style;
                    }
                },
            declutter: false,
            minResolution: layerInfo.minScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(layerInfo.minScale)] : myLayerTree._settings.resolutions[myLayerTree._settings.resolutions.length - 1],
            maxResolution: layerInfo.maxScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(layerInfo.maxScale)] + 0.1 : myLayerTree._settings.resolutions[0]
        });

        // Event for add feature
        vectorSource.on('addfeature', function (e) {

            // Add feature for snaping
            myLayerTree._mapSgs._snappingTool.snap.addFeature(e.feature);

            // Add feature for road build tool
            if (myLayerTree._mapSgs._settings._mapSettings.operation_visible.RoadBuilderTool) {

                let arrayFeature = myLayerTree._mapSgs._roadBuilderTool.collectionFeatureSet.getArray().map(c => c.getId());
                var posFeature = arrayFeature.findIndex(c => c == e.feature.getId());
                if (posFeature != -1) {
                    myLayerTree._mapSgs._roadBuilderTool.collectionFeatureSet.removeAt(posFeature);
                }
                myLayerTree._mapSgs._roadBuilderTool.collectionFeatureSet.push(e.feature);
            }

            // Add feature for traffic sign tool
            if (myLayerTree._mapSgs._settings._mapSettings.operation_visible.TrafficSignTool)
                myLayerTree._mapSgs._trafficSignTool.collectionFeatureSet.push(e.feature);

            // Add feature for manager traffic sign tool
            if (myLayerTree._mapSgs._settings._mapSettings.operation_visible.ManagerTrafficSignTool)
                myLayerTree._mapSgs._managerTrafficSignTool.collectionFeatureSet.push(e.feature);

            // Add feature for pub tool
            if (myLayerTree._mapSgs._settings._mapSettings.operation_visible.PubTool)
                myLayerTree._mapSgs._pubTool.collectionFeatureSet.push(e.feature);
        });

        // Evento for remove feature
        vectorSource.on('removefeature', function (e) {

            // Remove feature from snaping
            myLayerTree._mapSgs._snappingTool.snap.removeFeature(e.feature);

            // Remove feature for road build tool
            //if(myLayerTree._mapSgs._settings._mapSettings.operation_visible.RoadBuilderTool)
            //    myLayerTree._mapSgs._roadBuilderTool.collectionFeatureSet.removeFeature(e.feature);
        });

        // Add layer to map
        map.addLayer(vectorLayer);
    };

    /**
     * Create polygon dot pattern
     * @param {any} color
     */
    this._CreatePolygonDotPattern = function (color) {
        const canvas = document.createElement('canvas');
        canvas.width = 10; // Pattern size
        canvas.height = 10;
        const ctx = canvas.getContext('2d');

        // Draw a green dot
        ctx.fillStyle = color;
        ctx.beginPath();
        ctx.arc(5, 5, 2, 0, 2 * Math.PI); // Adjust size and position
        ctx.fill();

        return ctx.createPattern(canvas, 'repeat');
    }

    /**
     * Create wfs layer for sign (all sign radial)
     * @param {any} map
     * @param {any} layerInfo
     * @param {any} index
     */
    this._CreateLayerWFSForSign_radial = function (map, layerInfo, index) {

        const view = myLayerTree._mapSgs.map.getView();

        const calculateDistance = (feature, resolution) => {

            const properties = feature.getProperties();

            const diff = properties.qtd_sinais < 8 ? 3 : 2;

            var width = (properties.width < 100) ? 100 : properties.width;
            if (properties.scale_icon >= 1) {
                width += 50;
            }
            var distance = resolution * (width / diff);
            return distance;
        }

        // Set cql filter for vw_occurrence_event
        var cqlFilterResult = layerInfo.cqlFilter;

        // Vector Source
        var vectorSource = new VectorSource({
            visible: layerInfo.checked,
            format: new GeoJSON({ extractGeometryName: true }),
            loader: function (extent, resolution, projection) {
                // Clear layer label hash
                myLayerTree._hashLabelVisible = {};

                var layerInfoInUse = layerInfo;

                var proj = myLayerTree._settings.projection.getCode();
                var url = layerInfoInUse.geoserver + '/' + layerInfoInUse.workspace + '/ows?service=WFS&version=1.1.0&request=GetFeature'
                    + '&typename=' + layerInfoInUse.workspace + ':' + layerInfoInUse.layerName;
                if (layerInfoInUse.cqlFilter) {
                    url += '&cql_filter=' + encodeURI(cqlFilterResult) + " and BBOX(" + layerInfoInUse.geomColumnName + ", " + extent.join(',') + ")";
                } else {
                    url += '&bbox=' + extent.join(',');
                }
                url += '&outputFormat=application/json'
                    + '&srsname=' + proj;

                fetch(url)
                    .then(response => response.json())
                    .then(data => {
                        const features = vectorSource.getFormat().readFeatures(data);
                        vectorSource.addFeatures(features);

                        features.forEach(feature => {
                            relocateSignal(feature, calculateDistance(feature, view.getResolution()));
                        });

                        vectorSource.changed();
                    });
            },
            strategy: bbox
        });

        var vectorLayer = new VectorLayer({
            source: vectorSource,
            name: layerInfo.workspace + ":" + layerInfo.layerName + ":" + layerInfo.id,
            gpId: layerInfo.id,
            id: 'T' + layerInfo.id,
            zIndex: index,
            visible: layerInfo.checked,
            style: function (feature, resolution) {
                var properties = feature.getProperties();
                const idLayerPrumo = properties.id_prumo;
                const idLayerSign = `${feature.getId()}_${resolution}`;

                if (myLayerTree._cacheHidePrumoSigns[idLayerPrumo]) {
                    return null;
                }

                if (myLayerTree._cacheStyleLayerSign[idLayerSign])
                    return myLayerTree._cacheStyleLayerSign[idLayerSign].style;

                if (!myLayerTree._cacheStyleLayerSign[idLayerSign]) {
                    myLayerTree._cacheStyleLayerSign[idLayerSign] = {};
                }

                let colorSign = feature.getProperties().has_alarm ? "rgba(255, 255, 0, 0.7)" : "rgba(255, 255, 255, 0)";

                if (myLayerTree._mapSgs._managerTrafficSignTool.adicionalParameterInfo.idFeature == idLayerSign) {
                    colorSign = feature.getProperties().has_alarm ? colorSign = "rgba(255, 0, 0, 0.7)" : "rgba(255, 255, 0, 0.5)";
                }

                // Create icon style
                const iconStyle = new Style({
                    image: new Icon({
                        src: properties.file_img_name_sinal,
                        scale: properties.scale_icon || myLayerTree._mapSgs._managerTrafficSignTool.configInfo.scale,
                        color: colorSign
                    })
                });

                const lastCoord = feature.getGeometry().getCoordinates();

                // Create line style to connect base coordinate and displaced icon
                const lineStyle1 = new Style({
                    geometry: new LineString([properties.coord_prumo, Array.isArray(lastCoord[0]) ? lastCoord[0] : lastCoord]),
                    stroke: new Stroke({
                        color: 'rgba(255, 255, 255, 1)',
                        width: 2
                    })
                });
                const lineStyle2 = new Style({
                    geometry: new LineString([properties.coord_prumo, Array.isArray(lastCoord[0]) ? lastCoord[0] : lastCoord]),
                    stroke: new Stroke({
                        color: 'rgba(0, 0, 255, 1)',
                        width: 1,
                        lineDash: [2,2]
                    })
                });

                myLayerTree._cacheStyleLayerSign[idLayerSign] = {
                    style: [iconStyle, lineStyle1, lineStyle2]
                };

                return myLayerTree._cacheStyleLayerSign[idLayerSign].style;
            },
            declutter: false,
            minResolution: layerInfo.minScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(layerInfo.minScale)] : myLayerTree._settings.resolutions[myLayerTree._settings.resolutions.length - 1],
            maxResolution: layerInfo.maxScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(layerInfo.maxScale)] + 0.1 : myLayerTree._settings.resolutions[0]
        });

        const relocateSignal = (feature, baseDistance) => {
            let geometry = null;

            if (feature.get('coord_prumo') === undefined) {
                geometry = feature.getGeometry();
                feature.set('coord_prumo', geometry.getCoordinates()[0].slice());
            } else {
                geometry = new Point(feature.get('coord_prumo'));
                feature.setGeometry(geometry);
            }

            const properties = feature.getProperties();
            const idLayerPrumo = properties.id_prumo;

            if (properties.qtd_sinais > 4 && !myLayerTree._cacheHidePrumoSigns.hasOwnProperty(idLayerPrumo)) {
                myLayerTree._cacheHidePrumoSigns[idLayerPrumo] = true;
            }

            // Distance from the prumo to the signal
            let distance = baseDistance;

            if (properties.qtd_sinais > 8) {
                distance = properties.position_index % 2 == 0 ? baseDistance : baseDistance + 1;
            }

            // Calculate anchor offsets (normalized between 0 and 1 for fractional anchors)
            const angleStep = (2 * Math.PI) / properties.qtd_sinais; // Equal spacing for circular arrangement
            const angle = properties.position_index * angleStep; // Angle for this feature

            // Calculate anchor offsets (normalized between 0 and 1 for fractional anchors)
            const anchorX = 0.5 + Math.cos(angle); // Offset scale
            const anchorY = 0.5 - Math.sin(angle); // Offset scale

            // Calculate the virtual position of the icon in map coordinates for line drawing
            const iconOffsetX = (anchorX - 0.5) * distance;
            const iconOffsetY = (anchorY - 0.5) * distance;

            geometry.translate(iconOffsetX, iconOffsetY);
        }

        view.on('change:resolution', () => {
            if (vectorLayer.getVisible()) {
                vectorSource.getFeatures().map((feature) => relocateSignal(feature, calculateDistance(feature, view.getResolution())));
            }
        });

        // Add layer to map
        map.addLayer(vectorLayer);
    };

    /**
     * Create wfs layer for sign (all sign vertical)
     * @param {any} map
     * @param {any} layerInfo
     * @param {any} index
     */
    this._CreateLayerWFSForSign = function (map, layerInfo, index) {

        const view = myLayerTree._mapSgs.map.getView();

        const calculateDistance = (feature, resolution) => {

            const properties = feature.getProperties();
            const idLayerPrumo = properties.id_prumo || properties.id_suporte;

            const scale = properties.scale_icon || myLayerTree._mapSgs._managerTrafficSignTool.configInfo.scale;

            const imagenHeight = properties.height || 111;

            let pixels = scale * imagenHeight / 2;

            pixels += properties.position_index == 1 ? 40 : 10;

            if (!myLayerTree._cacheHidePrumoSigns.hasOwnProperty(idLayerPrumo)) {
                myLayerTree._cacheHidePrumoSigns[idLayerPrumo] = {
                    showSigns: properties.qtd_sinais <= 4,
                    signsPosition: {},
                    signsHeight: {}
                };
            }

            const lastIndexSign = properties.position_index - 1;
            const infoPrumo = myLayerTree._cacheHidePrumoSigns[idLayerPrumo];

            const lastPosition = infoPrumo.signsPosition[lastIndexSign] ? infoPrumo.signsPosition[lastIndexSign] : 0;
            const lastHeight = infoPrumo.signsHeight[lastIndexSign] ? infoPrumo.signsHeight[lastIndexSign] : 0;

            const distance = lastPosition + (resolution * pixels) + (resolution * lastHeight / 2);

            infoPrumo.signsPosition[properties.position_index] = distance;
            infoPrumo.signsHeight[properties.position_index] = scale * imagenHeight;

            return distance;
        }

        // Set cql filter for vw_occurrence_event
        var cqlFilterResult = layerInfo.cqlFilter;

        // Vector Source
        var vectorSource = new VectorSource({
            visible: layerInfo.checked,
            format: new GeoJSON({ extractGeometryName: true }),
            loader: function (extent, resolution, projection) {
                // Clear layer label hash
                myLayerTree._hashLabelVisible = {};

                var layerInfoInUse = layerInfo;

                var proj = myLayerTree._settings.projection.getCode();
                var url = layerInfoInUse.geoserver + '/' + layerInfoInUse.workspace + '/ows?service=WFS&version=1.1.0&request=GetFeature'
                    + '&typename=' + layerInfoInUse.workspace + ':' + layerInfoInUse.layerName;
                if (layerInfoInUse.cqlFilter) {
                    url += '&cql_filter=' + encodeURI(cqlFilterResult) + " and BBOX(" + layerInfoInUse.geomColumnName + ", " + extent.join(',') + ")";
                } else {
                    url += '&bbox=' + extent.join(',');
                }
                url += '&outputFormat=application/json'
                    + '&srsname=' + proj;

                fetch(url)
                    .then(response => response.json())
                    .then(data => {
                        const features = vectorSource.getFormat().readFeatures(data);
                        vectorSource.addFeatures(features);

                        features.forEach(feature => {
                            relocateSignal(feature, calculateDistance(feature, view.getResolution()));
                        });

                        vectorSource.changed();
                    });
            },
            strategy: bbox
        });

        var vectorLayer = new VectorLayer({
            source: vectorSource,
            name: layerInfo.workspace + ":" + layerInfo.layerName + ":" + layerInfo.id,
            gpId: layerInfo.id,
            id: 'T' + layerInfo.id,
            zIndex: index,
            visible: layerInfo.checked,
            style: function (feature, resolution) {
                const properties = feature.getProperties();
                const idLayerPrumo = properties.id_prumo;
                const idLayerSign = `${feature.getId()}_${resolution}`;

                if (myLayerTree._cacheHidePrumoSigns[idLayerPrumo] && !myLayerTree._cacheHidePrumoSigns[idLayerPrumo].showSigns) {
                    return null;
                }

                if (myLayerTree._cacheStyleLayerSign[idLayerSign])
                    return myLayerTree._cacheStyleLayerSign[idLayerSign].style;

                if (!myLayerTree._cacheStyleLayerSign[idLayerSign]) {
                    myLayerTree._cacheStyleLayerSign[idLayerSign] = {};
                }

                let colorSign = feature.getProperties().has_alarm ? "rgba(255, 255, 0, 0.7)" : "rgba(255, 255, 255, 0)";

                if (myLayerTree._mapSgs._managerTrafficSignTool.adicionalParameterInfo.idFeature == idLayerSign) {
                    colorSign = feature.getProperties().has_alarm ? colorSign = "rgba(255, 0, 0, 0.7)" : "rgba(255, 255, 0, 0.5)";
                }

                // Create icon style
                const iconStyle = new Style({
                    image: new Icon({
                        src: properties.file_img_name_sinal,
                        scale: properties.scale_icon || myLayerTree._mapSgs._managerTrafficSignTool.configInfo.scale,
                        color: colorSign
                    })
                });

                const lastCoord = feature.getGeometry().getCoordinates();

                // Create line style to connect base coordinate and displaced icon
                const lineStyle1 = new Style({
                    geometry: new LineString([properties.coord_prumo, Array.isArray(lastCoord[0]) ? lastCoord[0] : lastCoord]),
                    stroke: new Stroke({
                        color: 'rgba(255, 255, 255, 1)',
                        width: 2
                    })
                });
                const lineStyle2 = new Style({
                    geometry: new LineString([properties.coord_prumo, Array.isArray(lastCoord[0]) ? lastCoord[0] : lastCoord]),
                    stroke: new Stroke({
                        color: 'rgba(0, 0, 255, 1)',
                        width: 1,
                        lineDash: [2, 2]
                    })
                });

                myLayerTree._cacheStyleLayerSign[idLayerSign] = {
                    style: [iconStyle, lineStyle1, lineStyle2]
                };

                return myLayerTree._cacheStyleLayerSign[idLayerSign].style;
            },
            declutter: false,
            minResolution: layerInfo.minScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(layerInfo.minScale)] : myLayerTree._settings.resolutions[myLayerTree._settings.resolutions.length - 1],
            maxResolution: layerInfo.maxScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(layerInfo.maxScale)] + 0.1 : myLayerTree._settings.resolutions[0]
        });

        const relocateSignal = (feature, baseDistance) => {
            let geometry = null;

            if (feature.get('coord_prumo') === undefined) {
                geometry = feature.getGeometry();
                feature.set('coord_prumo', geometry.getCoordinates()[0].slice());
            } else {
                geometry = new Point(feature.get('coord_prumo'));
                feature.setGeometry(geometry);
            }

            // Distance from the prumo to the signal
            let distance = baseDistance;

            const angle = 4.7;

            // Calculate anchor offsets (normalized between 0 and 1 for fractional anchors)
            const anchorX = 0.5 + Math.cos(angle); // Offset scale
            const anchorY = 0.5 - Math.sin(angle); // Offset scale

            // Calculate the virtual position of the icon in map coordinates for line drawing
            const iconOffsetX = (anchorX - 0.5) * distance;
            const iconOffsetY = (anchorY - 0.5) * distance;

            geometry.translate(iconOffsetX, iconOffsetY);
        }

        view.on('change:resolution', () => {
            if (vectorLayer.getVisible()) {
                vectorSource.getFeatures().map((feature) => relocateSignal(feature, calculateDistance(feature, view.getResolution())));
            }
        });

        // Add layer to map
        map.addLayer(vectorLayer);
    };


    /**
     * Create wfs layer for sign (prumos with less than 5 signals are displayed radially and the rest vertically)
     * @param {any} map
     * @param {any} layerInfo
     * @param {any} index
     */
    this._CreateLayerWFSForSign_radial_vertical = function (map, layerInfo, index) {

        const view = myLayerTree._mapSgs.map.getView();

        const calculateDistance = (feature, resolution) => {

            const properties = feature.getProperties();
            let pixels = 0;

            if (properties.qtd_sinais > 4) {
                //pixels += (properties.height < 100) ? 100 : properties.height;
                pixels = 40;

                if (properties.scale_icon >= 1) {
                    pixels += 5;
                }
            } else {
                const diff = properties.qtd_sinais < 8 ? 3 : 2;

                pixels += (properties.width < 100) ? 100 : properties.width;

                if (properties.scale_icon >= 1) {
                    pixels += 50;
                }

                pixels = pixels / diff;
            }

            return resolution * pixels;
        }

        // Set cql filter for vw_occurrence_event
        var cqlFilterResult = layerInfo.cqlFilter;

        // Vector Source
        var vectorSource = new VectorSource({
            visible: layerInfo.checked,
            format: new GeoJSON({ extractGeometryName: true }),
            loader: function (extent, resolution, projection) {
                // Clear layer label hash
                myLayerTree._hashLabelVisible = {};

                var layerInfoInUse = layerInfo;

                var proj = myLayerTree._settings.projection.getCode();
                var url = layerInfoInUse.geoserver + '/' + layerInfoInUse.workspace + '/ows?service=WFS&version=1.1.0&request=GetFeature'
                    + '&typename=' + layerInfoInUse.workspace + ':' + layerInfoInUse.layerName;
                if (layerInfoInUse.cqlFilter) {
                    url += '&cql_filter=' + encodeURI(cqlFilterResult) + " and BBOX(" + layerInfoInUse.geomColumnName + ", " + extent.join(',') + ")";
                } else {
                    url += '&bbox=' + extent.join(',');
                }
                url += '&outputFormat=application/json'
                    + '&srsname=' + proj;

                fetch(url)
                    .then(response => response.json())
                    .then(data => {
                        const features = vectorSource.getFormat().readFeatures(data);
                        vectorSource.addFeatures(features);

                        features.forEach(feature => {
                            relocateSignal(feature, calculateDistance(feature, view.getResolution()));
                        });

                        vectorSource.changed();
                    });
            },
            strategy: bbox
        });

        var vectorLayer = new VectorLayer({
            source: vectorSource,
            name: layerInfo.workspace + ":" + layerInfo.layerName + ":" + layerInfo.id,
            gpId: layerInfo.id,
            id: 'T' + layerInfo.id,
            zIndex: index,
            visible: layerInfo.checked,
            style: function (feature, resolution) {
                const properties = feature.getProperties();
                const idLayerPrumo = properties.id_prumo;
                const idLayerSign = `${feature.getId()}_${resolution}`;

                if (myLayerTree._cacheHidePrumoSigns[idLayerPrumo] && !myLayerTree._cacheHidePrumoSigns[idLayerPrumo].showSigns) {
                    return null;
                }

                if (myLayerTree._cacheStyleLayerSign[idLayerSign])
                    return myLayerTree._cacheStyleLayerSign[idLayerSign].style;

                if (!myLayerTree._cacheStyleLayerSign[idLayerSign]) {
                    myLayerTree._cacheStyleLayerSign[idLayerSign] = {};
                }

                let colorSign = feature.getProperties().has_alarm ? "rgba(255, 255, 0, 0.7)" : "rgba(255, 255, 255, 0)";

                if (myLayerTree._mapSgs._managerTrafficSignTool.adicionalParameterInfo.idFeature == idLayerSign) {
                    colorSign = feature.getProperties().has_alarm ? colorSign = "rgba(255, 0, 0, 0.7)" : "rgba(255, 255, 0, 0.5)";
                }

                // Create icon style
                const iconStyle = new Style({
                    image: new Icon({
                        src: properties.file_img_name_sinal,
                        scale: properties.scale_icon || myLayerTree._mapSgs._managerTrafficSignTool.configInfo.scale,
                        color: colorSign
                    })
                });

                const lastCoord = feature.getGeometry().getCoordinates();

                // Create line style to connect base coordinate and displaced icon
                const lineStyle1 = new Style({
                    geometry: new LineString([properties.coord_prumo, Array.isArray(lastCoord[0]) ? lastCoord[0] : lastCoord]),
                    stroke: new Stroke({
                        color: 'rgba(255, 255, 255, 1)',
                        width: 2
                    })
                });
                const lineStyle2 = new Style({
                    geometry: new LineString([properties.coord_prumo, Array.isArray(lastCoord[0]) ? lastCoord[0] : lastCoord]),
                    stroke: new Stroke({
                        color: 'rgba(0, 0, 255, 1)',
                        width: 1,
                        lineDash: [2, 2]
                    })
                });

                myLayerTree._cacheStyleLayerSign[idLayerSign] = {
                    style: [iconStyle, lineStyle1, lineStyle2]
                };

                return myLayerTree._cacheStyleLayerSign[idLayerSign].style;
            },
            declutter: false,
            minResolution: layerInfo.minScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(layerInfo.minScale)] : myLayerTree._settings.resolutions[myLayerTree._settings.resolutions.length - 1],
            maxResolution: layerInfo.maxScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(layerInfo.maxScale)] + 0.1 : myLayerTree._settings.resolutions[0]
        });

        const relocateSignal = (feature, baseDistance) => {
            let geometry = null;

            if (feature.get('coord_prumo') === undefined) {
                geometry = feature.getGeometry();
                feature.set('coord_prumo', geometry.getCoordinates()[0].slice());
            } else {
                geometry = new Point(feature.get('coord_prumo'));
                feature.setGeometry(geometry);
            }

            const properties = feature.getProperties();
            const idLayerPrumo = properties.id_prumo;

            // Distance from the prumo to the signal
            let distance = baseDistance;

            // Calculate anchor offsets (normalized between 0 and 1 for fractional anchors)
            
            let angle = 0;

            if (properties.qtd_sinais > 4) {
                if (!myLayerTree._cacheHidePrumoSigns.hasOwnProperty(idLayerPrumo)) {
                    myLayerTree._cacheHidePrumoSigns[idLayerPrumo] = {
                        showSigns: false,
                        signsPosition: {}
                    };
                }

                angle = 4.7;

                const lastIndexSign = properties.position_index - 1;
                const lastPosition = myLayerTree._cacheHidePrumoSigns[idLayerPrumo].signsPosition[lastIndexSign] ? myLayerTree._cacheHidePrumoSigns[idLayerPrumo].signsPosition[lastIndexSign] : 0;
                
                distance += lastPosition;
                myLayerTree._cacheHidePrumoSigns[idLayerPrumo].signsPosition[properties.position_index] = distance;
            } else {
                const angleStep = (2 * Math.PI) / properties.qtd_sinais; // Equal spacing for circular arrangement
                angle = properties.position_index * angleStep; // Angle for this feature
            }

            // Calculate anchor offsets (normalized between 0 and 1 for fractional anchors)
            const anchorX = 0.5 + Math.cos(angle); // Offset scale
            const anchorY = 0.5 - Math.sin(angle); // Offset scale

            // Calculate the virtual position of the icon in map coordinates for line drawing
            const iconOffsetX = (anchorX - 0.5) * distance;
            const iconOffsetY = (anchorY - 0.5) * distance;

            geometry.translate(iconOffsetX, iconOffsetY);
        }

        view.on('change:resolution', () => {
            if (vectorLayer.getVisible()) {
                vectorSource.getFeatures().map((feature) => relocateSignal(feature, calculateDistance(feature, view.getResolution())));
            }
        });

        // Add layer to map
        map.addLayer(vectorLayer);
    };

    /**
     * Add a wfs invisible layer in the map
     * @param {any} map
     * @param {any} geoserver
     * @param {any} workspace
     * @param {any} layerName
     * @param {any} id
     * @param {any} index
     * @param {any} minScale
     * @param {any} maxScale
     */
    this._CreateInvisibleLayerWFS = function (map, geoserver, workspace, layerName, id, index, minScale, maxScale) {
        // Vector Source
        var vectorSource = new VectorSource({
            visible: true,
            format: new GeoJSON({ extractGeometryName: true }),
            url: function (extent) {
                var proj = myLayerTree._settings.projection.getCode();
                var url = geoserver + '/' + workspace + '/ows?service=WFS&version=1.1.0&request=GetFeature' +
                    '&typename=' + workspace + ':' + layerName + '&bbox=' + extent.join(',') + '&outputFormat=application/json' + '&srsname=' + proj;

                return url;
            },
            strategy: bbox
        });

        var style = new Style({
            stroke: new Stroke({
                color: "rgba(255, 255, 255, 0)",
                width: 0
            })
        });

        var vectorLayer = new VectorLayer({
            source: vectorSource,
            name: workspace + ":" + layerName + ":" + id,
            gpId: id,
            id: 'T' + id,
            zIndex: index,
            visible: true,
            style: style,
            declutter: false,
            minResolution: minScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(minScale)] : myLayerTree._settings.resolutions[myLayerTree._settings.resolutions.length - 1],
            maxResolution: maxScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(maxScale)] + 0.1 : myLayerTree._settings.resolutions[0]
        });

        // Event for add feature
        vectorSource.on('addfeature', function (e) {

            // Add feature for manager traffic sign tool
            if (myLayerTree._mapSgs._settings._mapSettings.operation_visible.ManagerTrafficSignTool)
                myLayerTree._mapSgs._managerTrafficSignTool.collectionFeatureSet.push(e.feature);
        });

        // Evento for remove feature
        vectorSource.on('removefeature', function (e) {

            // Remove feature from snaping
            myLayerTree._mapSgs._snappingTool.snap.removeFeature(e.feature);
        });

        // Add layer to map
        map.addLayer(vectorLayer);
    };

    /**
     * Add Mapserver type of layer
     * @param {ol.map} map, map
     * @param {object} layerInfo, layer information
     * @param {int} index
     */
    this._AddEsriLayerToMap = function (map, layerInfo, index) {
        switch (layerInfo.codServiceType) {
            case "MapServer":
                switch (layerInfo.kind) {
                    case "ImageEsri":
                        myLayerTree._AddImageEsriToMap(map, layerInfo, index);
                        break;
                    case "TileEsri":
                        myLayerTree._AddTileEsriToMap(map, layerInfo, index);
                        break;
                    case "VectorEsri":
                        myLayerTree._AddVectorEsriToMap(map, layerInfo, index);
                        break;
                    default:
                    // do nothing
                }
                break;
            case "FeatureServer":
                switch (layerInfo.kind) {
                    case "VectorEsri":
                        myLayerTree._AddVectorEsriToMap(map, layerInfo, index);
                        break;
                    default:
                    // do nothing
                }
                break;
            default:
            // do nothing
        }
    }

    /**
     * Add image esri to map
     * @param {ol.map} map, map
     * @param {object} layerInfo, layer information
     * @param {int} index
     */
    this._AddImageEsriToMap = function (map, layerInfo, index) {
        var imgLayer = new ImageLayer({
            name: layerInfo.layerName + ":" + layerInfo.id,
            gpId: layerInfo.id,
            id: 'T' + layerInfo.id,
            zIndex: index,
            visible: layerInfo.checked,
            source: new ImageArcGISRest({
                ratio: 1,
                params: { 'LAYERS': 'show:' + layerInfo.layerId },
                crossOrigin: 'anonymous',
                url: layerInfo.serviceNameUrl
            }),
            minResolution: layerInfo.minScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(layerInfo.minScale)] : myLayerTree._settings.resolutions[myLayerTree._settings.resolutions.length - 1],
            maxResolution: layerInfo.maxScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(layerInfo.maxScale)] + 0.1 : myLayerTree._settings.resolutions[0]
        });

        // Add layer to map
        map.addLayer(imgLayer);
    }

    /**
     * Add tile esri to map
     * @param {ol.map} map, map
     * @param {object} layerInfo, layer information
     * @param {int} index
     */
    this._AddTileEsriToMap = function (map, layerInfo, index) {
        var tileLayer = new TileLayer({
            name: layerInfo.workspace + ":" + layerInfo.layerName + ":" + layerInfo.id,
            gpId: layerInfo.id,
            id: 'T' + layerInfo.id,
            zIndex: index,
            visible: layerInfo.checked,
            source: new TileArcGISRest({
                ratio: 1,
                params: { 'LAYERS': 'show:' + layerInfo.layerId },
                crossOrigin: 'anonymous',
                url: layerInfo.serviceNameUrl
            }),
            minResolution: layerInfo.minScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(layerInfo.minScale)] : myLayerTree._settings.resolutions[myLayerTree._settings.resolutions.length - 1],
            maxResolution: layerInfo.maxScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(layerInfo.maxScale)] + 0.1 : myLayerTree._settings.resolutions[0]
        });

        // Add layer to map
        map.addLayer(tileLayer);
    }

    /**
     * Add vector esri to map
     * @param {ol.map} map, map
     * @param {object} layerInfo, layer information
     * @param {int} index
     */
    this._AddVectorEsriToMap = function (map, layerInfo, index) {
        var vectorSource = new VectorSource({
            format: new EsriJSON(),
            url: function (extent, resolution, projection) {
                const srid = map.getView().getProjection().getCode();

                var tokenParam = "";
                if (!layerInfo.isPublic && layerInfo.token !== undefined && layerInfo.token != "") {
                    tokenParam = "&token=" + layerInfo.token;
                }

                const url = layerInfo.serviceNameUrl + "/" + layerInfo.layerId +
                    '/query/?f=json' + tokenParam +
                    '&returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=' +
                    encodeURIComponent(
                        '{"xmin":' +
                        extent[0] +
                        ',"ymin":' +
                        extent[1] +
                        ',"xmax":' +
                        extent[2] +
                        ',"ymax":' +
                        extent[3] +
                        ',"spatialReference":{"wkid":' + srid + '}}'
                    ) +
                    '&geometryType=esriGeometryEnvelope&inSR=' +
                    srid +
                    '&outFields=*' +
                    '&outSR=' +
                    srid;

                return url;
            },
            strategy: tileStrategy(
                createXYZ({
                    tileSize: 512,
                })
            )
        });

        var vectorLayer = new VectorLayer({
            name: layerInfo.workspace + ":" + layerInfo.layerName + ":" + layerInfo.id,
            gpId: layerInfo.id,
            id: 'T' + layerInfo.id,
            zIndex: index,
            visible: layerInfo.checked,
            source: vectorSource,
            minResolution: layerInfo.minScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(layerInfo.minScale)] : myLayerTree._settings.resolutions[myLayerTree._settings.resolutions.length - 1],
            maxResolution: layerInfo.maxScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(layerInfo.maxScale)] + 0.1 : myLayerTree._settings.resolutions[0]
        });

        if (!layerInfo.isPublic && layerInfo.token !== undefined && layerInfo.token != "") {
            createStyleFunctionFromUrlWithToken(layerInfo.serviceNameUrl + "/" + layerInfo.layerId, map.getView().getProjection(), layerInfo.token).then((styleFunction) => {
                vectorLayer.setStyle(styleFunction);
            });
        }
        else {
            createStyleFunctionFromUrl(layerInfo.serviceNameUrl + "/" + layerInfo.layerId, map.getView().getProjection()).then((styleFunction) => {
                vectorLayer.setStyle(styleFunction);
            });
        }

        // Add layer to map
        map.addLayer(vectorLayer);
    }

    /**
     * Add multiple tile WMS Layer to Map
     * @param {ol.map} map, map
     * @param {string} id, id layer
     * @param {any} geoserver, geoserver
     * @param {any} workspace, workspace
     * @param {any} layerName, layer name
     * @param {any} cqlFilter, cql filter
     * @param {string} sldName, sld name
     * @param {boolean} state, state visible
     * @param {int} index, index
     * @param {any} minScale, min scale
     * @param {any} maxScale, max scale
     */
    this._AddWMSLayerToMap = function (map, id, geoserver, workspace, layerName, cqlFilter, sldName, state, index, minScale, maxScale) {
        var params = { 'LAYERS': workspace + ':' + layerName, 'TILED': true, 'VERSION': '1.1.1' };

        if (sldName)
            params.STYLES = workspace + ":" + sldName.replace('.sld', '');
        if (cqlFilter)
            params.cql_filter = cqlFilter; // + " and BBOX(geom, " + map.getView().calculateExtent().join(',') + ")";

        var matrixIds = [];
        for (var z = 0; z < myLayerTree._settings.resolutions.length; ++z) {
            matrixIds[z] = myLayerTree._settings.projection.getCode() + ":" + z;
        }

        var tileLayer = new TileLayer({
            name: workspace + ":" + layerName + ":" + id,
            gpId: id,
            visible: state,
            id: 'T' + id,
            zIndex: index,
            source: new TileWMS({
                url: geoserver + '/' + workspace + '/wms',
                params: params,
                serverType: 'geoserver',
                hidpi: false,
                transition: 0,
                tileGrid: new TileGrid({
                    tileSize: [256, 256],
                    //extent: myLayerTree._settings.extent,
                    origin: [myLayerTree._settings.center[0], myLayerTree._settings.center[1]],
                    resolutions: myLayerTree._settings.resolutions,
                    matrixIds: matrixIds
                }),
            }),
            minResolution: minScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(minScale)] : myLayerTree._settings.resolutions[myLayerTree._settings.resolutions.length - 1],
            maxResolution: maxScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(maxScale)] + 0.1 : myLayerTree._settings.resolutions[0]
        });

        // Add layer to map
        map.addLayer(tileLayer);
    };

    /**
     * Add external wms service
     */
    this._AddWMSExternalLayerToMap = function (map, id, urlIn, layerName, state, index, minScale, maxScale) {
        var url = urlIn.split("?")[0];

        var params = { 'LAYERS': layerName, 'TILED': true, 'VERSION': '1.1.1' };

        var tileLayer = new TileLayer({
            name: layerName + ":" + id,
            gpId: id,
            visible: state,
            id: 'T' + id,
            zIndex: index,
            source: new TileWMS({
                url: url,
                params: params,
                serverType: 'geoserver',
                hidpi: false,
                transition: 0
            }),
            minResolution: minScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(minScale)] : myLayerTree._settings.resolutions[myLayerTree._settings.resolutions.length - 1],
            maxResolution: maxScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(maxScale)] + 0.1 : myLayerTree._settings.resolutions[0]
        });

        // Add layer to map
        map.addLayer(tileLayer);
    };

    /**
     * Get capabilities wmts by url
     * @param {string} geoserver, geoserver url prefixe
     * @param {string} internalGeoserver, internal geoserver url
     */
    this._GetCapabilitiesWmts2 = function (url) {
        var parser = new WMTSCapabilities();
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, false);
        xhr.onload = function () {
            myLayerTree._settings._resultWmtsGetCapabilities[url] = parser.read(xhr.responseText);
        };
        xhr.send();
    }

    /**
     * Add External wmts service
     * @param {ol.map} map, map to add layer base
     * @param {any} layerInfo, layer information
     * @param {int} index, index
     */
    this._AddWMTSExternalLayerToMap = function (map, layerInfo, index) {
        var url = layerInfo.internalGeoserver;
        if (myLayerTree._settings._resultWmtsGetCapabilities[url] === undefined) {
            myLayerTree._GetCapabilitiesWmts2(url);
        }

        var options = optionsFromCapabilities(myLayerTree._settings._resultWmtsGetCapabilities[url], {
            layer: layerInfo.layerName,
            matrixSet: myLayerTree._settings.projection.getCode()
        });
        options.crossOrigin = 'anonymous';

        var tileLayer = new TileLayer({
            name: layerInfo.layerName + ":" + layerInfo.id,
            gpId: layerInfo.id,
            visible: layerInfo.checked,
            id: 'T' + layerInfo.id,
            zIndex: index,
            source: new WMTS(/** @type {!module:ol/source/WMTS~Options} */(options)),
            minResolution: layerInfo.minScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(layerInfo.minScale)] : myLayerTree._settings.resolutions[myLayerTree._settings.resolutions.length - 1],
            maxResolution: layerInfo.maxScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(layerInfo.maxScale)] + 0.1 : myLayerTree._settings.resolutions[0]
        });

        // Add tile layer to array
        map.addLayer(tileLayer);
    };

    /**
     * Add external wfs service
     */
    this._AddWFSExternalLayerToMap = function (map, layerInfo, index) {
        // Set cql filter for vw_occurrence_event
        var cqlFilterResult = layerInfo.cqlFilter;

        // Vector Source
        var vectorSource = new VectorSource({
            visible: layerInfo.checked,
            format: new GeoJSON({ extractGeometryName: true }),
            url: function (extent) {
                // Clear layer label hash
                myLayerTree._hashLabelVisible = {};

                var proj = myLayerTree._settings.projection.getCode();
                var url = layerInfo.internalGeoserver + '?service=WFS&version=1.1.0&request=GetFeature' + '&typename=' + layerInfo.layerName;
                if (layerInfo.cqlFilter) {
                    url += '&cql_filter=' + encodeURI(cqlFilterResult) + " and BBOX(" + layerInfo.geomColumnName + ", " + extent.join(',') + "," + proj + ")";
                } else {
                    url += '&bbox=' + extent.join(',') + "," + proj;
                }
                url += '&outputFormat=application/json'
                    + '&srsname=' + proj;

                return url;
            },
            strategy: bbox
        });

        var vectorLayer = new VectorLayer({
            source: vectorSource,
            name: layerInfo.layerName + ":" + layerInfo.id,
            gpId: layerInfo.id,
            id: 'T' + layerInfo.id,
            zIndex: index,
            visible: layerInfo.checked,
            //style: function (feature, resolution) {
            //    var styleBuild = [
            //        new Style({
            //            stroke: new Stroke({
            //                color: 'rgba(0, 0, 0, 1)',
            //                opacity: 1,
            //                width: 0.75
            //            }),
            //            fill: new Fill({
            //                color: 'rgba(100,100,100,0.25)'
            //            })
            //        }),
            //        new Style({
            //            image: new CircleStyle({
            //                radius: 5,
            //                stroke: new Stroke({
            //                    color: '#000000',
            //                    width: 3
            //                }),
            //                fill: new Fill({
            //                    color: 'rgba(255, 255, 255, 0.8)'
            //                })
            //            })
            //        })
            //    ];

            //    return styleBuild;
            //},
            declutter: false,
            minResolution: layerInfo.minScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(layerInfo.minScale)] : myLayerTree._settings.resolutions[myLayerTree._settings.resolutions.length - 1],
            maxResolution: layerInfo.maxScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(layerInfo.maxScale)] + 0.1 : myLayerTree._settings.resolutions[0]
        });

        // Event for add feature
        vectorSource.on('addfeature', function (e) {

            // Add feature for snaping
            myLayerTree._mapSgs._snappingTool.snap.addFeature(e.feature);

            // Add feature for road build tool
            if (myLayerTree._mapSgs._settings._mapSettings.operation_visible.RoadBuilderTool) {

                let arrayFeature = myLayerTree._mapSgs._roadBuilderTool.collectionFeatureSet.getArray().map(c => c.getId());
                var posFeature = arrayFeature.findIndex(c => c == e.feature.getId());
                if (posFeature != -1) {
                    myLayerTree._mapSgs._roadBuilderTool.collectionFeatureSet.removeAt(posFeature);
                }
                myLayerTree._mapSgs._roadBuilderTool.collectionFeatureSet.push(e.feature);
            }

            // Add feature for traffic sign tool
            if (myLayerTree._mapSgs._settings._mapSettings.operation_visible.TrafficSignTool)
                myLayerTree._mapSgs._trafficSignTool.collectionFeatureSet.push(e.feature);

            // Add feature for manager traffic sign tool
            if (myLayerTree._mapSgs._settings._mapSettings.operation_visible.ManagerTrafficSignTool)
                myLayerTree._mapSgs._managerTrafficSignTool.collectionFeatureSet.push(e.feature);

            // Add feature for pub tool
            if (myLayerTree._mapSgs._settings._mapSettings.operation_visible.PubTool)
                myLayerTree._mapSgs._pubTool.collectionFeatureSet.push(e.feature);
        });

        // Evento for remove feature
        vectorSource.on('removefeature', function (e) {

            // Remove feature from snaping
            myLayerTree._mapSgs._snappingTool.snap.removeFeature(e.feature);
        });

        // Add layer to map
        map.addLayer(vectorLayer);


        var sldText = '<?xml version="1.0" encoding="ISO-8859-1"?>' +
            '< StyledLayerDescriptor version = "1.0.0" xsi: schemaLocation = "http://www.opengis.net/sld http://schemas.opengis.net/sld/1.0.0/StyledLayerDescriptor.xsd" xmlns = "http://www.opengis.net/sld" xmlns: ogc = "http://www.opengis.net/ogc"        xmlns: xlink = "http://www.w3.org/1999/xlink" xmlns: xsi = "http://www.w3.org/2001/XMLSchema-instance" >' +
            '<NamedLayer>' +
            '    <Name></Name>' +
            '    <UserStyle>' +
            '        <Title>A cyan line style</Title>' +
            '        <FeatureTypeStyle>' +
            '            <Rule>' +
            '                <Title>cyan line</Title>' +
            '                <LineSymbolizer>' +
            '                    <Stroke>' +
            '                        <CssParameter name="stroke">#0099cc</CssParameter>' +
            '                    </Stroke>' +
            '                </LineSymbolizer>' +
            '            </Rule>' +
            '        </FeatureTypeStyle>' +
            '    </UserStyle>' +
            '</NamedLayer>' +
            '</StyledLayerDescriptor>';

        let sldString = '<?xml version="1.0" encoding="UTF-8"?><sld:StyledLayerDescriptor xmlns="http://www.opengis.net/sld" xmlns:sld="http://www.opengis.net/sld" xmlns:gml="http://www.opengis.net/gml" xmlns:ogc="http://www.opengis.net/ogc" version="1.0.0"> <sld:NamedLayer> <sld:Name>Default Styler</sld:Name> <sld:UserStyle> <sld:Name>Default Styler</sld:Name> <sld:Title>Gravel_Program_2016</sld:Title> <sld:FeatureTypeStyle> <sld:Name>name</sld:Name> <sld:Rule> <sld:MinScaleDenominator>1.0</sld:MinScaleDenominator> <sld:MaxScaleDenominator>1.0E7</sld:MaxScaleDenominator> <sld:LineSymbolizer> <sld:Stroke> <sld:CssParameter name="stroke">#8000FF</sld:CssParameter> <sld:CssParameter name="stroke-width">3.000</sld:CssParameter> </sld:Stroke> </sld:LineSymbolizer> </sld:Rule> </sld:FeatureTypeStyle> </sld:UserStyle> </sld:NamedLayer> </sld:StyledLayerDescriptor>';




        //myLayerTree._sldStyleParser2.readStyle(sldString).then(({ output: sldObject }) =>
        //    myLayerTree._olStyleParser2.writeStyle(sldObject).then(({ output: olStyle }) =>
        //        vectorLayer.setStyle(olStyle)
        //    )
        //);
    };


    /**
     * Add single tile external wms Layer to Map
     */
    this._AddWMSSTExternalLayerToMap = function (map, id, urlIn, layerName, state, index, minScale, maxScale) {
        var url = urlIn.split("?")[0];
        var params = { 'LAYERS': layerName, 'TILED': true, 'VERSION': '1.1.1' };

        var singleTileLayer = new ImageLayer({
            name: layerName + ":" + id,
            gpId: id,
            visible: state,
            id: 'T' + id,
            zIndex: index,
            source: new ImageWMS({
                url: url,
                params: params,
                ratio: 1
            }),
            minResolution: minScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(minScale)] : myLayerTree._settings.resolutions[myLayerTree._settings.resolutions.length - 1],
            maxResolution: maxScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(maxScale)] + 0.1 : myLayerTree._settings.resolutions[0]
        });

        // Add layer to map
        map.addLayer(singleTileLayer);
    };

    /**
     * Add single tile WMS Layer to Map
     * @param {ol.map} map, map
     * @param {string} id, id layer
     * @param {any} geoserver, geoserver
     * @param {any} workspace, workspace
     * @param {any} layerName, layer name
     * @param {any} cqlFilter, cql filter
     * @param {string} sldName, sld name
     * @param {boolean} state, state visible
     * @param {int} index, index
     * @param {any} minScale, min scale
     * @param {any} maxScale, max scale
     */
    this._AddWMSSTLayerToMap = function (map, id, geoserver, workspace, layerName, cqlFilter, sldName, state, index, minScale, maxScale) {

        var params = { 'LAYERS': workspace + ':' + layerName, 'TILED': true, 'VERSION': '1.1.1' };

        if (sldName)
            params.STYLES = workspace + ":" + sldName.replace('.sld', '');
        if (cqlFilter)
            params.cql_filter = cqlFilter;

        var singleTileLayer = new ImageLayer({
            name: workspace + ":" + layerName + ":" + id,
            gpId: id,
            visible: state,
            id: 'T' + id,
            zIndex: index,
            source: new ImageWMS({
                url: geoserver + '/' + workspace + '/wms',
                params: params,
                //serverType: 'geoserver',
                ratio: 1
            }), // ALERT: MaxResolution + 0.1 because: The maximum resolution (exclusive) below which this layer will be visible AND The minimum resolution (inclusive) at which this layer will be visible.
            minResolution: minScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(minScale)] : myLayerTree._settings.resolutions[myLayerTree._settings.resolutions.length - 1],
            maxResolution: maxScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(maxScale)] + 0.1 : myLayerTree._settings.resolutions[0]
        });

        // Add layer to map
        map.addLayer(singleTileLayer);
    };

    /**
     * Get capabilities wmts
     * @param {string} geoserver, geoserver url prefixe
     * @param {string} internalGeoserver, internal geoserver url
     */
    this._GetCapabilitiesWmts = function (workspace, geoserver, internalGeoserver) {
        var parser = new WMTSCapabilities();
        var newUrl = window.location.origin + geoserver + '/';
        var xhr = new XMLHttpRequest();
        xhr.open('GET', geoserver + '/' + workspace + '/gwc/service/wmts?REQUEST=GetCapabilities', false);
        xhr.onload = function () {
            switch (_geoserverAccess) {
                case "internal":
                    myLayerTree._settings._resultWmtsGetCapabilities[workspace + geoserver] = parser.read(xhr.responseText);
                    break;
                default:
                    myLayerTree._settings._resultWmtsGetCapabilities[workspace + geoserver] = parser.read(xhr.responseText.split(internalGeoserver).join(newUrl));
            }
        };
        xhr.send();
    }

    /**
     * Add Geoserver wmts layer to map
     * @param {ol.map} map, map
     * @param {string} id, id layer
     * @param {any} geoserver, geoserver
     * @param {any} workspace, workspace
     * @param {any} layerName, layer name
     * @param {any} cqlFilter, cql filter
     * @param {string} sldName, sld name
     * @param {boolean} state, state visible
     * @param {int} index, index
     * @param {any} minScale, min scale
     * @param {any} maxScale, max scale
     */
    this._AddWMTSLayerToMap = function (map, id, geoserver, workspace, layerName, cqlFilter, state, minScale, maxScale, internalGeoserver) {
        if (myLayerTree._settings._resultWmtsGetCapabilities[workspace + geoserver] === undefined) {
            myLayerTree._GetCapabilitiesWmts(workspace, geoserver, internalGeoserver);
        }

        var options = optionsFromCapabilities(myLayerTree._settings._resultWmtsGetCapabilities[workspace + geoserver], {
            layer: layerName,
            matrixSet: myLayerTree._settings.projection.getCode()
        });

        var tileLayer = new TileLayer({
            name: workspace + ":" + layerName + ":" + id,
            gpId: id,
            zIndex: -1,
            visible: state,
            id: 'T' + id,
            source: new WMTS(/** @type {!module:ol/source/WMTS~Options} */(options)),
            minResolution: minScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(minScale)] : myLayerTree._settings.resolutions[myLayerTree._settings.resolutions.length - 1],
            maxResolution: maxScale ? myLayerTree._settings.resolutions[myLayerTree._settings.scales.indexOf(maxScale)] : myLayerTree._settings.resolutions[0]
        });

        // Add tile layer to array
        map.addLayer(tileLayer);
    };


    /**
     * Get style default
     * @param {string} url, url
     */
    this._GetStyle = function (url) {
        return new Style({
            image: new Icon({
                src: url
            }),
            text: new Text({
                font: '12px Calibri,sans-serif',
                overflow: true,
                fill: new Fill({
                    color: '#000'
                }),
                stroke: new Stroke({
                    color: '#fff',
                    width: 3
                }),
                textBaseline: 'bottom',
                offsetY: -10
            })
        });
    };

    /**
     * Get feature property information
     */
    this.GetFeaturePropertyByName = function (layerInfo, allColumn) {
        var ListData = [];
        var geoserver = layerInfo.geoserver;

        let urlString = geoserver + "/wfs";
        let layerString = layerInfo.workspace + ':' + layerInfo.layerName;

        let Feature = $.ajax({
            method: "GET",
            async: true,
            url: urlString,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature ',
                "typeNames": layerString,
                "propertyName": allColumn,
                "outputFormat": 'application/json'
            }
        });

        Feature.done(function (data) {
            for (var i = 0; i < data.features.length; i++) {
                ListData.push(data.features[i].properties);
            }
        });

        return ListData;
    }

    /**
     * Build layer tree simpligied - main
     */
    this._BuildLayerTreeSimplified = function () {
        for (var i = 0; i < myLayerTree.layerTreeJson.dataSource.length; i++) {
            var objTree = myLayerTree.layerTreeJson.dataSource[i];

            // Check if group layer
            if (objTree.children.length > 0) {
                // Build layer group
                myLayerTree._BuildLayerTreeSimplifiedLayerGroup("id-layertree-simplified-body-layer", "layertree-simplified-body-layer-group", objTree.pretty_name, objTree.id);

                // Build layer group children
                myLayerTree._BuildLayerTreeSimplifiedLayerGroupChildren(objTree.id, objTree.children);
            }
        }
    }

    /**
     * Build layer tree simplified - build all children from layer group
     */
    this._BuildLayerTreeSimplifiedLayerGroupChildren = function (id, arrayChildren) {
        // Layer subgroup
        if (arrayChildren.length > 0) {
            for (var i = 0; i < arrayChildren.length; i++) {
                var objTree = arrayChildren[i];

                // Is subgroup
                if (objTree.children.length > 0) {
                    // Build layer subgroup
                    myLayerTree._BuildLayerTreeSimplifiedLayerGroup("id-layer-group-child-" + id, "layertree-simplified-body-layer-subgroup", objTree.pretty_name, objTree.id);

                    // Call recursive for all children from this subgroup
                    myLayerTree._BuildLayerTreeSimplifiedLayerGroupChildren(objTree.id, objTree.children)

                }
                else // Is layer
                {
                    // Build layer
                    myLayerTree._BuildLayerTreeSimplifiedLayer("id-layer-group-child-" + id + " ul", objTree);
                }
            }
        }
        else {
            // Build layer
            myLayerTree._BuildLayerTreeSimplifiedLayer("id-layer-group-child-" + id + " ul", objTree);
        }
    }

    /**
     * Build layer tree simplified - build group or subgroup of layer
     */
    this._BuildLayerTreeSimplifiedLayerGroup = function (idNodeToAppend, classGroup, prettyName, id) {
        //<div id="" class="layertree-simplified-body-layer-group"> or <div id="" class="layertree-simplified-body-layer-subgroup">
        //    <label></label>
        //</div>
        //<div id="">
        //   <ul></ul>
        //</div>

        // Title group
        const layerGroupTitleDiv = document.createElement('div');
        layerGroupTitleDiv.id = "id-layer-group-" + id;
        layerGroupTitleDiv.className = classGroup;
        layerGroupTitleDiv.setAttribute("id-layer-group", id);
        const layerGroupTitleLabel = document.createElement('label');
        layerGroupTitleLabel.innerHTML = prettyName;
        layerGroupTitleDiv.appendChild(layerGroupTitleLabel);
        $('#' + idNodeToAppend)[0].appendChild(layerGroupTitleDiv);

        // Ul for all the layer
        const layerGroupChildZoneDiv = document.createElement('div');
        layerGroupChildZoneDiv.id = "id-layer-group-child-" + id;
        const layerGroupChildZoneUl = document.createElement('ul');
        layerGroupChildZoneDiv.appendChild(layerGroupChildZoneUl);
        $('#' + idNodeToAppend)[0].appendChild(layerGroupChildZoneDiv);

        // Event hide or show all layer of the group or subgroup
        layerGroupTitleDiv.addEventListener('click', function () {
            var idLayerGroup = $(this).attr("id-layer-group");
            var idLayerGroupChild = "id-layer-group-child-" + idLayerGroup;

            if ($('#' + idLayerGroupChild).is(":visible"))
                $('#' + idLayerGroupChild).hide();
            else
                $('#' + idLayerGroupChild).show();
        });
    }

    /**
     * Build layer tree simplified - build layer
     */
    this._BuildLayerTreeSimplifiedLayer = function (idNodeToAppend, layerInfo) {
        //<li>
        //    <button type="button" class="layertree-simplified-body-layer-cell select">
        //        <div class="visibility-layer ol-hidden"></div>
        //        <div class="legend-image"></div>
        //        <div class="layer-name">
        //            <span></span>
        //        </div>
        //        <div class="layer-feature-count">
        //            <span></span>
        //        </div>
        //    </button>
        //</li>

        // Li
        const layerLi = document.createElement('li');
        layerLi.id = "id-layer-" + layerInfo.id;
        $('#' + idNodeToAppend)[0].appendChild(layerLi);
        // Button
        const layerButton = document.createElement('button');
        layerButton.setAttribute("type", "button");
        layerButton.setAttribute("id-layer", layerInfo.id);
        layerButton.className = "layertree-simplified-body-layer-cell";
        if (layerInfo.checked)
            layerButton.className += " select";
        layerLi.appendChild(layerButton);
        // Visible layer
        const layerVisibilityDiv = document.createElement('div');
        layerVisibilityDiv.className = "visibility-layer";
        if (!layerInfo.checked)
            layerVisibilityDiv.className += " ol-hidden";
        layerButton.appendChild(layerVisibilityDiv);
        // Legend image
        const layerLegendDiv = document.createElement('div');
        layerLegendDiv.className = "legend-image";
        layerLegendDiv.innerHTML = layerInfo.imageHtml;
        layerButton.appendChild(layerLegendDiv);
        // Name layer
        const layerNameDiv = document.createElement('div');
        layerNameDiv.className = "layer-name";
        layerButton.appendChild(layerNameDiv);
        const layerNameSpan = document.createElement('span');
        layerNameSpan.innerHTML = layerInfo.pretty_name;
        layerNameDiv.appendChild(layerNameSpan);
        // Count layer
        const layerCountDiv = document.createElement('div');
        layerCountDiv.className = "layer-feature-count ol-hidden";
        if (myLayerTree._settings.getVisibleOperations().LayerTreeCount)
            layerCountDiv.className = "layer-feature-count";
        layerButton.appendChild(layerCountDiv);
        const layerCountSpan = document.createElement('span');
        layerCountSpan.innerHTML = 0;
        layerCountDiv.appendChild(layerCountSpan);

        // Event layer visible or not visible
        layerButton.addEventListener('click', function () {
            var idLayer = this.getAttribute('id-layer');

            // Get layer info
            var layerInfo = myLayerTree.layerInfo.dict_layer_info[idLayer];

            // Layer visibility
            if ($(this).hasClass('select')) {
                // Hide layer
                myLayerTree._utility.GetLayerByName(myLayerTree._mapSgs.map, layerInfo.layer_info.layerNameKey).setVisible(false);
            }
            else {
                // View layer
                myLayerTree._utility.GetLayerByName(myLayerTree._mapSgs.map, layerInfo.layer_info.layerNameKey).setVisible(true);
            }

            // Sift visibility button design
            $(this).find(".visibility-layer").toggleClass('ol-hidden');
            $(this).toggleClass('select');
        });
    };

    /**
     * Count layer feature in extent
     */
    this._CountLayerFeatureInExtent = function (idLayer, extent, idNodeResult) {
        var layerInfo = myLayerTree.layerInfo.dict_layer_info[idLayer];

        if (layerInfo === undefined)
            return;

        var getFeatureUrl = layerInfo.layer_info.geoserver + "/wfs";

        // Call geoserver to get the feature of the layer
        //var getFeature = $.ajax({
        //    method: "GET",
        //    async: async,
        //    url: getFeatureUrl,
        //    data: {
        //        "service": 'wfs',
        //        "version": '2.0.0',
        //        "request": 'GetFeature',
        //        "typeNames": layerInfo.layer_info.workspace + ':' + layerInfo.layer_info.layerName,
        //        "propertyName": layerInfo.layer_info..geomColumnName,
        //        "srsName": myMapSgs._settings.projection.code_,
        //        "outputFormat": 'application/json',
        //        "bbox": extent.join(',')
        //    }
        //});

        // Result
        //getFeature.done(function (data, textStatus, jqXHR) {
        //    if (data.features)
        //    {
        //        var countFeature = data.features.length 
        //    }
        //    else
        //    {

        //    }
        //});
    }

    // -- end private method ----------------------------------------------------------------------

    // -- start event -----------------------------------------------------------------------------

    /**
     * Event put all layer visible or put all layer not visible
     */
    $('#id-layertree-simplified-body-btn-show-all').off('click').on('click', function () {

        // For for all layer
        for (var i = 0; i < $('.layertree-simplified-body-layer-cell').length; i++) {
            var cell = $('.layertree-simplified-body-layer-cell')[i];
            var idLayer = cell.getAttribute('id-layer');
            // Get layer info
            var layerInfo = myLayerTree.layerInfo.dict_layer_info[idLayer];

            // Layer visibility
            if (!$(cell).hasClass('select')) {
                // View layer
                myLayerTree._utility.GetLayerByName(myLayerTree._mapSgs.map, layerInfo.layer_info.layerNameKey).setVisible(true);

                // Sift visibility button design
                $(cell).find(".visibility-layer").toggleClass('ol-hidden');
                $(cell).toggleClass('select');
            }
        }

    })

    /**
 * Event full screen legend in layer tree panel
 */
    $('#id-layer-legend-img-button-full').on('click', function () {

        if ($(this).hasClass('full')) {
            $(this).removeClass('full');
            $(this).find("i").html = "fullscreen_exit";
            $('#layer-tree').show();
        }
        else {
            $(this).addClass('full');
            $(this).find("i").html = "fullscreen";
            $('#layer-tree').hide();
        }
    });

    /**
     * Event close legend
     */
    $('#id-layer-legend-img-button-close').on('click', function () {
        // Close legend visibility
        $('#id-layer-legend-img').hide();

        // Reset view from layer external zone
        $('#id-layer-tree-external-zone').show();
        $('#id-offcanvas-theme-footer').show();

        // View layer tree
        $('#layer-tree').show();
    });
    // -- end event -------------------------------------------------------------------------------
};